// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/capture.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.datagateway.v1.CaptureProject
 */ export class CaptureProject extends Message {
    static fromBinary(bytes, options) {
        return new CaptureProject().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureProject().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureProject().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureProject, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string zou_project_id = 3;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string account_id = 5;
   */ _define_property(this, "accountId", ""), /**
   * @generated from field: string customer_org_id = 6;
   */ _define_property(this, "customerOrgId", ""), /**
   * Deprecated phase alias: shaping|qualifying|pursuing|unknown
   *
   * @generated from field: string stage = 7;
   */ _define_property(this, "stage", ""), /**
   * @generated from field: string opportunity_hypothesis = 8;
   */ _define_property(this, "opportunityHypothesis", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */ _define_property(this, "deletedAt", void 0), /**
   * active|parked|closed; UI labels Active/Parked/Closed
   *
   * @generated from field: string lifecycle = 12;
   */ _define_property(this, "lifecycle", ""), /**
   * shaping|qualifying|pursuing|unknown (stage compatibility alias)
   *
   * @generated from field: string business_phase = 13;
   */ _define_property(this, "businessPhase", ""), /**
   * @generated from field: int64 lifecycle_revision = 14;
   */ _define_property(this, "lifecycleRevision", protoInt64.zero), /**
   * @generated from field: google.protobuf.Timestamp lifecycle_revisit_at = 15;
   */ _define_property(this, "lifecycleRevisitAt", void 0), /**
   * GRW-17: surgery edges. Read-only here: only PursuitGraphGatewayService.ApplySurgery writes them.
   *
   * @generated from field: string split_from_id = 16;
   */ _define_property(this, "splitFromId", ""), /**
   * set = a merged, read-only stub
   *
   * @generated from field: string merged_into_id = 17;
   */ _define_property(this, "mergedIntoId", ""), /**
   * @generated from field: google.protobuf.Timestamp merged_at = 18;
   */ _define_property(this, "mergedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureProject, "runtime", proto3);
_define_property(CaptureProject, "typeName", "mono.datagateway.v1.CaptureProject");
_define_property(CaptureProject, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "account_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "opportunity_hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "business_phase",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "lifecycle_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 15,
            name: "lifecycle_revisit_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "split_from_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "merged_into_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "merged_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiEvent
 */ export class RfiEvent extends Message {
    static fromBinary(bytes, options) {
        return new RfiEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string source_notice_id = 4;
   */ _define_property(this, "sourceNoticeId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * sources_sought|rfi|draft_rfp|industry_day|other
   *
   * @generated from field: string rfi_type = 6;
   */ _define_property(this, "rfiType", ""), /**
   * @generated from field: google.protobuf.Timestamp event_date = 7;
   */ _define_property(this, "eventDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp response_due = 8;
   */ _define_property(this, "responseDue", void 0), /**
   * @generated from field: string questions = 9;
   */ _define_property(this, "questions", ""), /**
   * @generated from field: string response_artifact_id = 10;
   */ _define_property(this, "responseArtifactId", ""), /**
   * @generated from field: string impacted_requirements_json = 11;
   */ _define_property(this, "impactedRequirementsJson", ""), /**
   * @generated from field: string impacted_vehicle_strategy = 12;
   */ _define_property(this, "impactedVehicleStrategy", ""), /**
   * @generated from field: string notes = 13;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 16;
   */ _define_property(this, "deletedAt", void 0), /**
   * pending|responded|not_responded|missed. Empty = not recorded (on upsert:
   * leave the stored value unchanged).
   *
   * @generated from field: string response_status = 17;
   */ _define_property(this, "responseStatus", ""), /**
   * Why we did not respond (not_responded / missed).
   *
   * @generated from field: string response_reason = 18;
   */ _define_property(this, "responseReason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEvent, "runtime", proto3);
_define_property(RfiEvent, "typeName", "mono.datagateway.v1.RfiEvent");
_define_property(RfiEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rfi_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "event_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "questions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "response_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "impacted_requirements_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "impacted_vehicle_strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "response_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "response_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CustomerInteraction
 */ export class CustomerInteraction extends Message {
    static fromBinary(bytes, options) {
        return new CustomerInteraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerInteraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerInteraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerInteraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: google.protobuf.Timestamp interaction_date = 4;
   */ _define_property(this, "interactionDate", void 0), /**
   * meeting|email|call|conference|other
   *
   * @generated from field: string channel = 5;
   */ _define_property(this, "channel", ""), /**
   * @generated from field: string stakeholder = 6;
   */ _define_property(this, "stakeholder", ""), /**
   * @generated from field: string summary = 7;
   */ _define_property(this, "summary", ""), /**
   * positive|neutral|negative|unknown
   *
   * @generated from field: string sentiment = 8;
   */ _define_property(this, "sentiment", ""), /**
   * @generated from field: string follow_ups = 9;
   */ _define_property(this, "followUps", ""), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 13;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: optional string title = 14;
   */ _define_property(this, "title", void 0), /**
   * @generated from field: optional bool is_draft = 15;
   */ _define_property(this, "isDraft", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.TouchpointParticipant participants = 16;
   */ _define_property(this, "participants", []), /**
   * @generated from field: string inferred_need = 17;
   */ _define_property(this, "inferredNeed", ""), /**
   * GRW-36: the govcon.events row this touchpoint happened at. On write:
   * unset = keep the stored event; "" = clear it (removes no event links).
   *
   * @generated from field: optional string event_id = 18;
   */ _define_property(this, "eventId", void 0), /**
   * read-only: govcon.events.title at request time
   *
   * @generated from field: string event_title = 19;
   */ _define_property(this, "eventTitle", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerInteraction, "runtime", proto3);
_define_property(CustomerInteraction, "typeName", "mono.datagateway.v1.CustomerInteraction");
_define_property(CustomerInteraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "interaction_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "channel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "stakeholder",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sentiment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "follow_ups",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 15,
            name: "is_draft",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 16,
            name: "participants",
            kind: "message",
            T: TouchpointParticipant,
            repeated: true
        },
        {
            no: 17,
            name: "inferred_need",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 19,
            name: "event_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureWorkstreamItem
 */ export class CaptureWorkstreamItem extends Message {
    static fromBinary(bytes, options) {
        return new CaptureWorkstreamItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureWorkstreamItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureWorkstreamItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureWorkstreamItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * One of the 8 §4 workstreams. zou maps the projectdata
   * CaptureWorkstreamType enum to/from this string.
   *
   * @generated from field: string workstream_type = 4;
   */ _define_property(this, "workstreamType", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 6;
   */ _define_property(this, "body", ""), /**
   * open|in_progress|done|parked
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string data_json = 8;
   */ _define_property(this, "dataJson", ""), /**
   * @generated from field: bool ai_drafted = 9;
   */ _define_property(this, "aiDrafted", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureWorkstreamItem, "runtime", proto3);
_define_property(CaptureWorkstreamItem, "typeName", "mono.datagateway.v1.CaptureWorkstreamItem");
_define_property(CaptureWorkstreamItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "data_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "ai_drafted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * --- CaptureProject ---
 *
 * @generated from message mono.datagateway.v1.CreateCaptureProjectRequest
 */ export class CreateCaptureProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProject capture_project = 1;
   */ _define_property(this, "captureProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureProjectRequest, "runtime", proto3);
_define_property(CreateCaptureProjectRequest, "typeName", "mono.datagateway.v1.CreateCaptureProjectRequest");
_define_property(CreateCaptureProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project",
            kind: "message",
            T: CaptureProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCaptureProjectResponse
 */ export class CreateCaptureProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCaptureProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCaptureProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCaptureProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCaptureProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProject capture_project = 1;
   */ _define_property(this, "captureProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCaptureProjectResponse, "runtime", proto3);
_define_property(CreateCaptureProjectResponse, "typeName", "mono.datagateway.v1.CreateCaptureProjectResponse");
_define_property(CreateCaptureProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project",
            kind: "message",
            T: CaptureProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCaptureProjectRequest
 */ export class UpdateCaptureProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCaptureProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCaptureProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCaptureProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCaptureProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProject capture_project = 1;
   */ _define_property(this, "captureProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCaptureProjectRequest, "runtime", proto3);
_define_property(UpdateCaptureProjectRequest, "typeName", "mono.datagateway.v1.UpdateCaptureProjectRequest");
_define_property(UpdateCaptureProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project",
            kind: "message",
            T: CaptureProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCaptureProjectResponse
 */ export class UpdateCaptureProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCaptureProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCaptureProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCaptureProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCaptureProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProject capture_project = 1;
   */ _define_property(this, "captureProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCaptureProjectResponse, "runtime", proto3);
_define_property(UpdateCaptureProjectResponse, "typeName", "mono.datagateway.v1.UpdateCaptureProjectResponse");
_define_property(UpdateCaptureProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project",
            kind: "message",
            T: CaptureProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureProjectRequest
 */ export class GetCaptureProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureProjectRequest, "runtime", proto3);
_define_property(GetCaptureProjectRequest, "typeName", "mono.datagateway.v1.GetCaptureProjectRequest");
_define_property(GetCaptureProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureProjectResponse
 */ export class GetCaptureProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProject capture_project = 1;
   */ _define_property(this, "captureProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureProjectResponse, "runtime", proto3);
_define_property(GetCaptureProjectResponse, "typeName", "mono.datagateway.v1.GetCaptureProjectResponse");
_define_property(GetCaptureProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project",
            kind: "message",
            T: CaptureProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureProjectsRequest
 */ export class ListCaptureProjectsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureProjectsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureProjectsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureProjectsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureProjectsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureProjectsRequest, "runtime", proto3);
_define_property(ListCaptureProjectsRequest, "typeName", "mono.datagateway.v1.ListCaptureProjectsRequest");
_define_property(ListCaptureProjectsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureProjectsResponse
 */ export class ListCaptureProjectsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureProjectsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureProjectsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureProjectsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureProjectsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureProject capture_projects = 1;
   */ _define_property(this, "captureProjects", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureProjectsResponse, "runtime", proto3);
_define_property(ListCaptureProjectsResponse, "typeName", "mono.datagateway.v1.ListCaptureProjectsResponse");
_define_property(ListCaptureProjectsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_projects",
            kind: "message",
            T: CaptureProject,
            repeated: true
        }
    ]));
/**
 * --- RfiEvent ---
 * Upsert: empty capture_project.id (here rfi_event.id) creates; otherwise updates.
 *
 * @generated from message mono.datagateway.v1.UpsertRfiEventRequest
 */ export class UpsertRfiEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertRfiEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertRfiEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertRfiEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertRfiEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvent rfi_event = 1;
   */ _define_property(this, "rfiEvent", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertRfiEventRequest, "runtime", proto3);
_define_property(UpsertRfiEventRequest, "typeName", "mono.datagateway.v1.UpsertRfiEventRequest");
_define_property(UpsertRfiEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_event",
            kind: "message",
            T: RfiEvent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertRfiEventResponse
 */ export class UpsertRfiEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertRfiEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertRfiEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertRfiEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertRfiEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvent rfi_event = 1;
   */ _define_property(this, "rfiEvent", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertRfiEventResponse, "runtime", proto3);
_define_property(UpsertRfiEventResponse, "typeName", "mono.datagateway.v1.UpsertRfiEventResponse");
_define_property(UpsertRfiEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_event",
            kind: "message",
            T: RfiEvent
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiEventRequest
 */ export class GetRfiEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiEventRequest, "runtime", proto3);
_define_property(GetRfiEventRequest, "typeName", "mono.datagateway.v1.GetRfiEventRequest");
_define_property(GetRfiEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiEventResponse
 */ export class GetRfiEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiEvent rfi_event = 1;
   */ _define_property(this, "rfiEvent", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiEventResponse, "runtime", proto3);
_define_property(GetRfiEventResponse, "typeName", "mono.datagateway.v1.GetRfiEventResponse");
_define_property(GetRfiEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_event",
            kind: "message",
            T: RfiEvent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiEventsRequest
 */ export class ListRfiEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiEventsRequest, "runtime", proto3);
_define_property(ListRfiEventsRequest, "typeName", "mono.datagateway.v1.ListRfiEventsRequest");
_define_property(ListRfiEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiEventsResponse
 */ export class ListRfiEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiEvent rfi_events = 1;
   */ _define_property(this, "rfiEvents", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiEventsResponse, "runtime", proto3);
_define_property(ListRfiEventsResponse, "typeName", "mono.datagateway.v1.ListRfiEventsResponse");
_define_property(ListRfiEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_events",
            kind: "message",
            T: RfiEvent,
            repeated: true
        }
    ]));
/**
 * --- CustomerInteraction ---
 *
 * @generated from message mono.datagateway.v1.UpsertCustomerInteractionRequest
 */ export class UpsertCustomerInteractionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCustomerInteractionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCustomerInteractionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCustomerInteractionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCustomerInteractionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerInteraction interaction = 1;
   */ _define_property(this, "interaction", void 0), /**
   * Atomic patch: omitted/empty leaves participants intact. Existing attendee
   * context is immutable; resolution only changes its canonical link.
   *
   * @generated from field: repeated mono.datagateway.v1.TouchpointParticipant participant_upserts = 2;
   */ _define_property(this, "participantUpserts", []), /**
   * @generated from field: repeated string participant_removals = 3;
   */ _define_property(this, "participantRemovals", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCustomerInteractionRequest, "runtime", proto3);
_define_property(UpsertCustomerInteractionRequest, "typeName", "mono.datagateway.v1.UpsertCustomerInteractionRequest");
_define_property(UpsertCustomerInteractionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "interaction",
            kind: "message",
            T: CustomerInteraction
        },
        {
            no: 2,
            name: "participant_upserts",
            kind: "message",
            T: TouchpointParticipant,
            repeated: true
        },
        {
            no: 3,
            name: "participant_removals",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCustomerInteractionResponse
 */ export class UpsertCustomerInteractionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCustomerInteractionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCustomerInteractionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCustomerInteractionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCustomerInteractionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerInteraction interaction = 1;
   */ _define_property(this, "interaction", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCustomerInteractionResponse, "runtime", proto3);
_define_property(UpsertCustomerInteractionResponse, "typeName", "mono.datagateway.v1.UpsertCustomerInteractionResponse");
_define_property(UpsertCustomerInteractionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "interaction",
            kind: "message",
            T: CustomerInteraction
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCustomerInteractionRequest
 */ export class GetCustomerInteractionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerInteractionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerInteractionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerInteractionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerInteractionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerInteractionRequest, "runtime", proto3);
_define_property(GetCustomerInteractionRequest, "typeName", "mono.datagateway.v1.GetCustomerInteractionRequest");
_define_property(GetCustomerInteractionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCustomerInteractionResponse
 */ export class GetCustomerInteractionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerInteractionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerInteractionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerInteractionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerInteractionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerInteraction interaction = 1;
   */ _define_property(this, "interaction", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerInteractionResponse, "runtime", proto3);
_define_property(GetCustomerInteractionResponse, "typeName", "mono.datagateway.v1.GetCustomerInteractionResponse");
_define_property(GetCustomerInteractionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "interaction",
            kind: "message",
            T: CustomerInteraction
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCustomerInteractionsRequest
 */ export class ListCustomerInteractionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerInteractionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerInteractionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerInteractionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerInteractionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerInteractionsRequest, "runtime", proto3);
_define_property(ListCustomerInteractionsRequest, "typeName", "mono.datagateway.v1.ListCustomerInteractionsRequest");
_define_property(ListCustomerInteractionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCustomerInteractionsResponse
 */ export class ListCustomerInteractionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerInteractionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerInteractionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerInteractionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerInteractionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CustomerInteraction interactions = 1;
   */ _define_property(this, "interactions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerInteractionsResponse, "runtime", proto3);
_define_property(ListCustomerInteractionsResponse, "typeName", "mono.datagateway.v1.ListCustomerInteractionsResponse");
_define_property(ListCustomerInteractionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "interactions",
            kind: "message",
            T: CustomerInteraction,
            repeated: true
        }
    ]));
/**
 * --- CaptureWorkstreamItem ---
 *
 * @generated from message mono.datagateway.v1.UpsertWorkstreamItemRequest
 */ export class UpsertWorkstreamItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertWorkstreamItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertWorkstreamItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertWorkstreamItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertWorkstreamItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureWorkstreamItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertWorkstreamItemRequest, "runtime", proto3);
_define_property(UpsertWorkstreamItemRequest, "typeName", "mono.datagateway.v1.UpsertWorkstreamItemRequest");
_define_property(UpsertWorkstreamItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: CaptureWorkstreamItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertWorkstreamItemResponse
 */ export class UpsertWorkstreamItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertWorkstreamItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertWorkstreamItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertWorkstreamItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertWorkstreamItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureWorkstreamItem item = 1;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertWorkstreamItemResponse, "runtime", proto3);
_define_property(UpsertWorkstreamItemResponse, "typeName", "mono.datagateway.v1.UpsertWorkstreamItemResponse");
_define_property(UpsertWorkstreamItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: CaptureWorkstreamItem
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWorkstreamItemRequest
 */ export class GetWorkstreamItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkstreamItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkstreamItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkstreamItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkstreamItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkstreamItemRequest, "runtime", proto3);
_define_property(GetWorkstreamItemRequest, "typeName", "mono.datagateway.v1.GetWorkstreamItemRequest");
_define_property(GetWorkstreamItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWorkstreamItemResponse
 */ export class GetWorkstreamItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkstreamItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkstreamItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkstreamItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkstreamItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureWorkstreamItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkstreamItemResponse, "runtime", proto3);
_define_property(GetWorkstreamItemResponse, "typeName", "mono.datagateway.v1.GetWorkstreamItemResponse");
_define_property(GetWorkstreamItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: CaptureWorkstreamItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamItemsRequest
 */ export class ListWorkstreamItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * Optional filter; empty returns all workstreams.
   *
   * @generated from field: string workstream_type = 3;
   */ _define_property(this, "workstreamType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamItemsRequest, "runtime", proto3);
_define_property(ListWorkstreamItemsRequest, "typeName", "mono.datagateway.v1.ListWorkstreamItemsRequest");
_define_property(ListWorkstreamItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamItemsResponse
 */ export class ListWorkstreamItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureWorkstreamItem items = 1;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamItemsResponse, "runtime", proto3);
_define_property(ListWorkstreamItemsResponse, "typeName", "mono.datagateway.v1.ListWorkstreamItemsResponse");
_define_property(ListWorkstreamItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: CaptureWorkstreamItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalMilestone
 */ export class ProposalMilestone extends Message {
    static fromBinary(bytes, options) {
        return new ProposalMilestone().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalMilestone().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalMilestone().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalMilestone, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", ""), /**
   * Type string: "proposal_due" | "questions_due" | "oral_presentation" |
   * "colour_team_pink" | "colour_team_red" | "colour_team_gold" |
   * "internal_draft" | "other"
   *
   * @generated from field: string milestone_type = 4;
   */ _define_property(this, "milestoneType", ""), /**
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * @generated from field: google.protobuf.Timestamp scheduled_at = 6;
   */ _define_property(this, "scheduledAt", void 0), /**
   * "pipeline" rows are seeded by the insights sync; "user" rows are manual.
   *
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * PRP-03: set when the milestone is marked done; unset = not done.
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 11;
   */ _define_property(this, "completedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalMilestone, "runtime", proto3);
_define_property(ProposalMilestone, "typeName", "mono.datagateway.v1.ProposalMilestone");
_define_property(ProposalMilestone, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "milestone_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "scheduled_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertProposalMilestoneRequest
 */ export class UpsertProposalMilestoneRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProposalMilestoneRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProposalMilestoneRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProposalMilestoneRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProposalMilestoneRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalMilestone milestone = 1;
   */ _define_property(this, "milestone", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProposalMilestoneRequest, "runtime", proto3);
_define_property(UpsertProposalMilestoneRequest, "typeName", "mono.datagateway.v1.UpsertProposalMilestoneRequest");
_define_property(UpsertProposalMilestoneRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "milestone",
            kind: "message",
            T: ProposalMilestone
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertProposalMilestoneResponse
 */ export class UpsertProposalMilestoneResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProposalMilestoneResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProposalMilestoneResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProposalMilestoneResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProposalMilestoneResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalMilestone milestone = 1;
   */ _define_property(this, "milestone", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProposalMilestoneResponse, "runtime", proto3);
_define_property(UpsertProposalMilestoneResponse, "typeName", "mono.datagateway.v1.UpsertProposalMilestoneResponse");
_define_property(UpsertProposalMilestoneResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "milestone",
            kind: "message",
            T: ProposalMilestone
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProposalMilestonesRequest
 */ export class ListProposalMilestonesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalMilestonesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalMilestonesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalMilestonesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalMilestonesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalMilestonesRequest, "runtime", proto3);
_define_property(ListProposalMilestonesRequest, "typeName", "mono.datagateway.v1.ListProposalMilestonesRequest");
_define_property(ListProposalMilestonesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProposalMilestonesResponse
 */ export class ListProposalMilestonesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalMilestonesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalMilestonesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalMilestonesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalMilestonesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalMilestone milestones = 1;
   */ _define_property(this, "milestones", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalMilestonesResponse, "runtime", proto3);
_define_property(ListProposalMilestonesResponse, "typeName", "mono.datagateway.v1.ListProposalMilestonesResponse");
_define_property(ListProposalMilestonesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "milestones",
            kind: "message",
            T: ProposalMilestone,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProposalMilestoneRequest
 */ export class DeleteProposalMilestoneRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProposalMilestoneRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProposalMilestoneRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProposalMilestoneRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProposalMilestoneRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 3;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProposalMilestoneRequest, "runtime", proto3);
_define_property(DeleteProposalMilestoneRequest, "typeName", "mono.datagateway.v1.DeleteProposalMilestoneRequest");
_define_property(DeleteProposalMilestoneRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProposalMilestoneResponse
 */ export class DeleteProposalMilestoneResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProposalMilestoneResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProposalMilestoneResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProposalMilestoneResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProposalMilestoneResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProposalMilestoneResponse, "runtime", proto3);
_define_property(DeleteProposalMilestoneResponse, "typeName", "mono.datagateway.v1.DeleteProposalMilestoneResponse");
_define_property(DeleteProposalMilestoneResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * CaptureProposalLink records that a proposal was spawned from a pursuit.
 *
 * Cardinality is one source capture per proposal, many proposals per capture
 * (doc 09 models the handoff as 1 -> 0..N so a vehicle split can fork). Rows
 * soft-delete so a detach leaves an auditable tombstone.
 *
 * @generated from message mono.datagateway.v1.CaptureProposalLink
 */ export class CaptureProposalLink extends Message {
    static fromBinary(bytes, options) {
        return new CaptureProposalLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureProposalLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureProposalLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureProposalLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * Pangaea pursuit id (govcon.capture_projects.id).
   *
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * ZOU project id of the spawned proposal — no FK, zou owns that row.
   *
   * @generated from field: string proposal_project_id = 4;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string created_by = 5;
   */ _define_property(this, "createdBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureProposalLink, "runtime", proto3);
_define_property(CaptureProposalLink, "typeName", "mono.datagateway.v1.CaptureProposalLink");
_define_property(CaptureProposalLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureProposalLinkRequest
 */ export class UpsertCaptureProposalLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureProposalLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureProposalLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureProposalLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureProposalLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProposalLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureProposalLinkRequest, "runtime", proto3);
_define_property(UpsertCaptureProposalLinkRequest, "typeName", "mono.datagateway.v1.UpsertCaptureProposalLinkRequest");
_define_property(UpsertCaptureProposalLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureProposalLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureProposalLinkResponse
 */ export class UpsertCaptureProposalLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureProposalLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureProposalLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureProposalLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureProposalLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProposalLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureProposalLinkResponse, "runtime", proto3);
_define_property(UpsertCaptureProposalLinkResponse, "typeName", "mono.datagateway.v1.UpsertCaptureProposalLinkResponse");
_define_property(UpsertCaptureProposalLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureProposalLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureProposalLinksRequest
 */ export class ListCaptureProposalLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureProposalLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureProposalLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureProposalLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureProposalLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Filter by pursuit — "which proposals came from this capture". Optional.
   *
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * Filter by proposal — the convert idempotency guard. Optional.
   *
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureProposalLinksRequest, "runtime", proto3);
_define_property(ListCaptureProposalLinksRequest, "typeName", "mono.datagateway.v1.ListCaptureProposalLinksRequest");
_define_property(ListCaptureProposalLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureProposalLinksResponse
 */ export class ListCaptureProposalLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureProposalLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureProposalLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureProposalLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureProposalLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureProposalLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureProposalLinksResponse, "runtime", proto3);
_define_property(ListCaptureProposalLinksResponse, "typeName", "mono.datagateway.v1.ListCaptureProposalLinksResponse");
_define_property(ListCaptureProposalLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CaptureProposalLink,
            repeated: true
        }
    ]));
/**
 * ProposalOpening is the Proposal's own row, keyed by its zou project id. The
 * source capture is a reference only: the Pursuit's lifecycle never changes
 * because a bid opened from it, and one Pursuit may source several openings.
 *
 * @generated from message mono.datagateway.v1.ProposalOpening
 */ export class ProposalOpening extends Message {
    static fromBinary(bytes, options) {
        return new ProposalOpening().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalOpening().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalOpening().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalOpening, a, b);
    }
    constructor(data){
        super(), /**
   * The proposal's zou project id.
   *
   * @generated from field: string proposal_project_id = 1;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * Idempotency key of the opening action; empty when none was supplied.
   *
   * @generated from field: string open_request_key = 3;
   */ _define_property(this, "openRequestKey", ""), /**
   * pursuit | direct | legacy_conversion
   *
   * @generated from field: string source_kind = 4;
   */ _define_property(this, "sourceKind", ""), /**
   * Source pursuit (govcon.capture_projects.id); empty for direct openings.
   *
   * @generated from field: string source_capture_project_id = 5;
   */ _define_property(this, "sourceCaptureProjectId", ""), /**
   * @generated from field: string owner_user_id = 6;
   */ _define_property(this, "ownerUserId", ""), /**
   * Access is the proposal's own, e.g. proposal_members.
   *
   * @generated from field: string access_mode = 7;
   */ _define_property(this, "accessMode", ""), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalOpening, "runtime", proto3);
_define_property(ProposalOpening, "typeName", "mono.datagateway.v1.ProposalOpening");
_define_property(ProposalOpening, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "open_request_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "access_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ClaimProposalOpeningRequest
 */ export class ClaimProposalOpeningRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClaimProposalOpeningRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClaimProposalOpeningRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClaimProposalOpeningRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClaimProposalOpeningRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Required. Candidate proposal id, used only if no opening exists yet for
   * open_request_key (or for this id).
   *
   * @generated from field: mono.datagateway.v1.ProposalOpening opening = 1;
   */ _define_property(this, "opening", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClaimProposalOpeningRequest, "runtime", proto3);
_define_property(ClaimProposalOpeningRequest, "typeName", "mono.datagateway.v1.ClaimProposalOpeningRequest");
_define_property(ClaimProposalOpeningRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opening",
            kind: "message",
            T: ProposalOpening
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ClaimProposalOpeningResponse
 */ export class ClaimProposalOpeningResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClaimProposalOpeningResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClaimProposalOpeningResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClaimProposalOpeningResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClaimProposalOpeningResponse, a, b);
    }
    constructor(data){
        super(), /**
   * The winning row: the existing one on a retry, else the one just inserted.
   *
   * @generated from field: mono.datagateway.v1.ProposalOpening opening = 1;
   */ _define_property(this, "opening", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClaimProposalOpeningResponse, "runtime", proto3);
_define_property(ClaimProposalOpeningResponse, "typeName", "mono.datagateway.v1.ClaimProposalOpeningResponse");
_define_property(ClaimProposalOpeningResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opening",
            kind: "message",
            T: ProposalOpening
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * GetProposalOpening looks one up by proposal_project_id or open_request_key
 * (exactly one). Returns NOT_FOUND when absent.
 *
 * @generated from message mono.datagateway.v1.GetProposalOpeningRequest
 */ export class GetProposalOpeningRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalOpeningRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalOpeningRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalOpeningRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalOpeningRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string open_request_key = 3;
   */ _define_property(this, "openRequestKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalOpeningRequest, "runtime", proto3);
_define_property(GetProposalOpeningRequest, "typeName", "mono.datagateway.v1.GetProposalOpeningRequest");
_define_property(GetProposalOpeningRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "open_request_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProposalOpeningResponse
 */ export class GetProposalOpeningResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalOpeningResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalOpeningResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalOpeningResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalOpeningResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalOpening opening = 1;
   */ _define_property(this, "opening", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalOpeningResponse, "runtime", proto3);
_define_property(GetProposalOpeningResponse, "typeName", "mono.datagateway.v1.GetProposalOpeningResponse");
_define_property(GetProposalOpeningResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opening",
            kind: "message",
            T: ProposalOpening
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiResponseProject
 */ export class RfiResponseProject extends Message {
    static fromBinary(bytes, options) {
        return new RfiResponseProject().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiResponseProject().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiResponseProject().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiResponseProject, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string zou_project_id = 3;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string source_notice_id = 5;
   */ _define_property(this, "sourceNoticeId", ""), /**
   * @generated from field: google.protobuf.Timestamp response_due = 6;
   */ _define_property(this, "responseDue", void 0), /**
   * draft|in_progress|submitted|closed
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * JSON array of {title, status}
   *
   * @generated from field: string sections_json = 8;
   */ _define_property(this, "sectionsJson", ""), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0), /**
   * WRT-06 (004604): submission facts and page budget inputs. Read-only here:
   * Create/UpdateRfiResponseProject never write them; use
   * RfiWorkspaceGatewayService.UpdateRfiSubmissionFacts.
   *
   * @generated from field: double page_limit = 13;
   */ _define_property(this, "pageLimit", 0), /**
   * @generated from field: int32 word_limit = 14;
   */ _define_property(this, "wordLimit", 0), /**
   * @generated from field: int32 words_per_page = 15;
   */ _define_property(this, "wordsPerPage", 0), /**
   * @generated from field: string submission_format = 16;
   */ _define_property(this, "submissionFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp questions_due = 18;
   */ _define_property(this, "questionsDue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiResponseProject, "runtime", proto3);
_define_property(RfiResponseProject, "typeName", "mono.datagateway.v1.RfiResponseProject");
_define_property(RfiResponseProject, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sections_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "page_limit",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "word_limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "words_per_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "submission_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "questions_due",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRfiResponseProjectRequest
 */ export class CreateRfiResponseProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiResponseProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiResponseProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiResponseProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiResponseProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiResponseProject rfi_response_project = 1;
   */ _define_property(this, "rfiResponseProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiResponseProjectRequest, "runtime", proto3);
_define_property(CreateRfiResponseProjectRequest, "typeName", "mono.datagateway.v1.CreateRfiResponseProjectRequest");
_define_property(CreateRfiResponseProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project",
            kind: "message",
            T: RfiResponseProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRfiResponseProjectResponse
 */ export class CreateRfiResponseProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiResponseProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiResponseProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiResponseProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiResponseProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiResponseProject rfi_response_project = 1;
   */ _define_property(this, "rfiResponseProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiResponseProjectResponse, "runtime", proto3);
_define_property(CreateRfiResponseProjectResponse, "typeName", "mono.datagateway.v1.CreateRfiResponseProjectResponse");
_define_property(CreateRfiResponseProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project",
            kind: "message",
            T: RfiResponseProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiResponseProjectRequest
 */ export class GetRfiResponseProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiResponseProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiResponseProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiResponseProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiResponseProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Pangaea row id. Provide this OR zou_project_id.
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string zou_project_id = 3;
   */ _define_property(this, "zouProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiResponseProjectRequest, "runtime", proto3);
_define_property(GetRfiResponseProjectRequest, "typeName", "mono.datagateway.v1.GetRfiResponseProjectRequest");
_define_property(GetRfiResponseProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiResponseProjectResponse
 */ export class GetRfiResponseProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiResponseProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiResponseProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiResponseProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiResponseProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiResponseProject rfi_response_project = 1;
   */ _define_property(this, "rfiResponseProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiResponseProjectResponse, "runtime", proto3);
_define_property(GetRfiResponseProjectResponse, "typeName", "mono.datagateway.v1.GetRfiResponseProjectResponse");
_define_property(GetRfiResponseProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project",
            kind: "message",
            T: RfiResponseProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateRfiResponseProjectRequest
 */ export class UpdateRfiResponseProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiResponseProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiResponseProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiResponseProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiResponseProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiResponseProject rfi_response_project = 1;
   */ _define_property(this, "rfiResponseProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiResponseProjectRequest, "runtime", proto3);
_define_property(UpdateRfiResponseProjectRequest, "typeName", "mono.datagateway.v1.UpdateRfiResponseProjectRequest");
_define_property(UpdateRfiResponseProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project",
            kind: "message",
            T: RfiResponseProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateRfiResponseProjectResponse
 */ export class UpdateRfiResponseProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiResponseProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiResponseProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiResponseProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiResponseProjectResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiResponseProject rfi_response_project = 1;
   */ _define_property(this, "rfiResponseProject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiResponseProjectResponse, "runtime", proto3);
_define_property(UpdateRfiResponseProjectResponse, "typeName", "mono.datagateway.v1.UpdateRfiResponseProjectResponse");
_define_property(UpdateRfiResponseProjectResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project",
            kind: "message",
            T: RfiResponseProject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SoftDeleteRfiResponseProjectRequest
 */ export class SoftDeleteRfiResponseProjectRequest extends Message {
    static fromBinary(bytes, options) {
        return new SoftDeleteRfiResponseProjectRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SoftDeleteRfiResponseProjectRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SoftDeleteRfiResponseProjectRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SoftDeleteRfiResponseProjectRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SoftDeleteRfiResponseProjectRequest, "runtime", proto3);
_define_property(SoftDeleteRfiResponseProjectRequest, "typeName", "mono.datagateway.v1.SoftDeleteRfiResponseProjectRequest");
_define_property(SoftDeleteRfiResponseProjectRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SoftDeleteRfiResponseProjectResponse
 */ export class SoftDeleteRfiResponseProjectResponse extends Message {
    static fromBinary(bytes, options) {
        return new SoftDeleteRfiResponseProjectResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SoftDeleteRfiResponseProjectResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SoftDeleteRfiResponseProjectResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SoftDeleteRfiResponseProjectResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SoftDeleteRfiResponseProjectResponse, "runtime", proto3);
_define_property(SoftDeleteRfiResponseProjectResponse, "typeName", "mono.datagateway.v1.SoftDeleteRfiResponseProjectResponse");
_define_property(SoftDeleteRfiResponseProjectResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.CaptureRfiResponseLink
 */ export class CaptureRfiResponseLink extends Message {
    static fromBinary(bytes, options) {
        return new CaptureRfiResponseLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureRfiResponseLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureRfiResponseLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureRfiResponseLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 4;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string created_by = 5;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureRfiResponseLink, "runtime", proto3);
_define_property(CaptureRfiResponseLink, "typeName", "mono.datagateway.v1.CaptureRfiResponseLink");
_define_property(CaptureRfiResponseLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureRfiResponseLinkRequest
 */ export class UpsertCaptureRfiResponseLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureRfiResponseLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureRfiResponseLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureRfiResponseLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureRfiResponseLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureRfiResponseLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureRfiResponseLinkRequest, "runtime", proto3);
_define_property(UpsertCaptureRfiResponseLinkRequest, "typeName", "mono.datagateway.v1.UpsertCaptureRfiResponseLinkRequest");
_define_property(UpsertCaptureRfiResponseLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureRfiResponseLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureRfiResponseLinkResponse
 */ export class UpsertCaptureRfiResponseLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureRfiResponseLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureRfiResponseLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureRfiResponseLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureRfiResponseLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureRfiResponseLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureRfiResponseLinkResponse, "runtime", proto3);
_define_property(UpsertCaptureRfiResponseLinkResponse, "typeName", "mono.datagateway.v1.UpsertCaptureRfiResponseLinkResponse");
_define_property(UpsertCaptureRfiResponseLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureRfiResponseLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SoftDeleteCaptureRfiResponseLinkRequest
 */ export class SoftDeleteCaptureRfiResponseLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new SoftDeleteCaptureRfiResponseLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SoftDeleteCaptureRfiResponseLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SoftDeleteCaptureRfiResponseLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SoftDeleteCaptureRfiResponseLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SoftDeleteCaptureRfiResponseLinkRequest, "runtime", proto3);
_define_property(SoftDeleteCaptureRfiResponseLinkRequest, "typeName", "mono.datagateway.v1.SoftDeleteCaptureRfiResponseLinkRequest");
_define_property(SoftDeleteCaptureRfiResponseLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SoftDeleteCaptureRfiResponseLinkResponse
 */ export class SoftDeleteCaptureRfiResponseLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new SoftDeleteCaptureRfiResponseLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SoftDeleteCaptureRfiResponseLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SoftDeleteCaptureRfiResponseLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SoftDeleteCaptureRfiResponseLinkResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SoftDeleteCaptureRfiResponseLinkResponse, "runtime", proto3);
_define_property(SoftDeleteCaptureRfiResponseLinkResponse, "typeName", "mono.datagateway.v1.SoftDeleteCaptureRfiResponseLinkResponse");
_define_property(SoftDeleteCaptureRfiResponseLinkResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureRfiResponseLinksRequest
 */ export class ListCaptureRfiResponseLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureRfiResponseLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureRfiResponseLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureRfiResponseLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureRfiResponseLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 3;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureRfiResponseLinksRequest, "runtime", proto3);
_define_property(ListCaptureRfiResponseLinksRequest, "typeName", "mono.datagateway.v1.ListCaptureRfiResponseLinksRequest");
_define_property(ListCaptureRfiResponseLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureRfiResponseLinksResponse
 */ export class ListCaptureRfiResponseLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureRfiResponseLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureRfiResponseLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureRfiResponseLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureRfiResponseLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureRfiResponseLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureRfiResponseLinksResponse, "runtime", proto3);
_define_property(ListCaptureRfiResponseLinksResponse, "typeName", "mono.datagateway.v1.ListCaptureRfiResponseLinksResponse");
_define_property(ListCaptureRfiResponseLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CaptureRfiResponseLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposalRfiResponseLink
 */ export class ProposalRfiResponseLink extends Message {
    static fromBinary(bytes, options) {
        return new ProposalRfiResponseLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalRfiResponseLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalRfiResponseLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalRfiResponseLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 4;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string created_by = 5;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalRfiResponseLink, "runtime", proto3);
_define_property(ProposalRfiResponseLink, "typeName", "mono.datagateway.v1.ProposalRfiResponseLink");
_define_property(ProposalRfiResponseLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertProposalRfiResponseLinkRequest
 */ export class UpsertProposalRfiResponseLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProposalRfiResponseLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProposalRfiResponseLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProposalRfiResponseLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProposalRfiResponseLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalRfiResponseLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProposalRfiResponseLinkRequest, "runtime", proto3);
_define_property(UpsertProposalRfiResponseLinkRequest, "typeName", "mono.datagateway.v1.UpsertProposalRfiResponseLinkRequest");
_define_property(UpsertProposalRfiResponseLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: ProposalRfiResponseLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertProposalRfiResponseLinkResponse
 */ export class UpsertProposalRfiResponseLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProposalRfiResponseLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProposalRfiResponseLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProposalRfiResponseLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProposalRfiResponseLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProposalRfiResponseLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProposalRfiResponseLinkResponse, "runtime", proto3);
_define_property(UpsertProposalRfiResponseLinkResponse, "typeName", "mono.datagateway.v1.UpsertProposalRfiResponseLinkResponse");
_define_property(UpsertProposalRfiResponseLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: ProposalRfiResponseLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SoftDeleteProposalRfiResponseLinkRequest
 */ export class SoftDeleteProposalRfiResponseLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new SoftDeleteProposalRfiResponseLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SoftDeleteProposalRfiResponseLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SoftDeleteProposalRfiResponseLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SoftDeleteProposalRfiResponseLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SoftDeleteProposalRfiResponseLinkRequest, "runtime", proto3);
_define_property(SoftDeleteProposalRfiResponseLinkRequest, "typeName", "mono.datagateway.v1.SoftDeleteProposalRfiResponseLinkRequest");
_define_property(SoftDeleteProposalRfiResponseLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SoftDeleteProposalRfiResponseLinkResponse
 */ export class SoftDeleteProposalRfiResponseLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new SoftDeleteProposalRfiResponseLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SoftDeleteProposalRfiResponseLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SoftDeleteProposalRfiResponseLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SoftDeleteProposalRfiResponseLinkResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SoftDeleteProposalRfiResponseLinkResponse, "runtime", proto3);
_define_property(SoftDeleteProposalRfiResponseLinkResponse, "typeName", "mono.datagateway.v1.SoftDeleteProposalRfiResponseLinkResponse");
_define_property(SoftDeleteProposalRfiResponseLinkResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.ListProposalRfiResponseLinksRequest
 */ export class ListProposalRfiResponseLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalRfiResponseLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalRfiResponseLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalRfiResponseLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalRfiResponseLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string proposal_project_id = 2;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string rfi_response_project_id = 3;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalRfiResponseLinksRequest, "runtime", proto3);
_define_property(ListProposalRfiResponseLinksRequest, "typeName", "mono.datagateway.v1.ListProposalRfiResponseLinksRequest");
_define_property(ListProposalRfiResponseLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProposalRfiResponseLinksResponse
 */ export class ListProposalRfiResponseLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalRfiResponseLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalRfiResponseLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalRfiResponseLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalRfiResponseLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProposalRfiResponseLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalRfiResponseLinksResponse, "runtime", proto3);
_define_property(ListProposalRfiResponseLinksResponse, "typeName", "mono.datagateway.v1.ListProposalRfiResponseLinksResponse");
_define_property(ListProposalRfiResponseLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: ProposalRfiResponseLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OpportunityRfiResponseLink
 */ export class OpportunityRfiResponseLink extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityRfiResponseLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityRfiResponseLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityRfiResponseLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityRfiResponseLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string rfi_response_project_id = 4;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string created_by = 5;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityRfiResponseLink, "runtime", proto3);
_define_property(OpportunityRfiResponseLink, "typeName", "mono.datagateway.v1.OpportunityRfiResponseLink");
_define_property(OpportunityRfiResponseLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertOpportunityRfiResponseLinkRequest
 */ export class UpsertOpportunityRfiResponseLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertOpportunityRfiResponseLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertOpportunityRfiResponseLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertOpportunityRfiResponseLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertOpportunityRfiResponseLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityRfiResponseLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertOpportunityRfiResponseLinkRequest, "runtime", proto3);
_define_property(UpsertOpportunityRfiResponseLinkRequest, "typeName", "mono.datagateway.v1.UpsertOpportunityRfiResponseLinkRequest");
_define_property(UpsertOpportunityRfiResponseLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: OpportunityRfiResponseLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertOpportunityRfiResponseLinkResponse
 */ export class UpsertOpportunityRfiResponseLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertOpportunityRfiResponseLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertOpportunityRfiResponseLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertOpportunityRfiResponseLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertOpportunityRfiResponseLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityRfiResponseLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertOpportunityRfiResponseLinkResponse, "runtime", proto3);
_define_property(UpsertOpportunityRfiResponseLinkResponse, "typeName", "mono.datagateway.v1.UpsertOpportunityRfiResponseLinkResponse");
_define_property(UpsertOpportunityRfiResponseLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: OpportunityRfiResponseLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SoftDeleteOpportunityRfiResponseLinkRequest
 */ export class SoftDeleteOpportunityRfiResponseLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new SoftDeleteOpportunityRfiResponseLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SoftDeleteOpportunityRfiResponseLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SoftDeleteOpportunityRfiResponseLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SoftDeleteOpportunityRfiResponseLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SoftDeleteOpportunityRfiResponseLinkRequest, "runtime", proto3);
_define_property(SoftDeleteOpportunityRfiResponseLinkRequest, "typeName", "mono.datagateway.v1.SoftDeleteOpportunityRfiResponseLinkRequest");
_define_property(SoftDeleteOpportunityRfiResponseLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SoftDeleteOpportunityRfiResponseLinkResponse
 */ export class SoftDeleteOpportunityRfiResponseLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new SoftDeleteOpportunityRfiResponseLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SoftDeleteOpportunityRfiResponseLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SoftDeleteOpportunityRfiResponseLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SoftDeleteOpportunityRfiResponseLinkResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SoftDeleteOpportunityRfiResponseLinkResponse, "runtime", proto3);
_define_property(SoftDeleteOpportunityRfiResponseLinkResponse, "typeName", "mono.datagateway.v1.SoftDeleteOpportunityRfiResponseLinkResponse");
_define_property(SoftDeleteOpportunityRfiResponseLinkResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.ListOpportunityRfiResponseLinksRequest
 */ export class ListOpportunityRfiResponseLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityRfiResponseLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityRfiResponseLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityRfiResponseLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityRfiResponseLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string rfi_response_project_id = 3;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityRfiResponseLinksRequest, "runtime", proto3);
_define_property(ListOpportunityRfiResponseLinksRequest, "typeName", "mono.datagateway.v1.ListOpportunityRfiResponseLinksRequest");
_define_property(ListOpportunityRfiResponseLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOpportunityRfiResponseLinksResponse
 */ export class ListOpportunityRfiResponseLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityRfiResponseLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityRfiResponseLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityRfiResponseLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityRfiResponseLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OpportunityRfiResponseLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityRfiResponseLinksResponse, "runtime", proto3);
_define_property(ListOpportunityRfiResponseLinksResponse, "typeName", "mono.datagateway.v1.ListOpportunityRfiResponseLinksResponse");
_define_property(ListOpportunityRfiResponseLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: OpportunityRfiResponseLink,
            repeated: true
        }
    ]));
/**
 * One named factor accumulating on the pursuit. Tenant-ish free text; the
 * id is stable so an edit of the body does not look like a new factor.
 *
 * @generated from message mono.datagateway.v1.GoNoGoFactor
 */ export class GoNoGoFactor extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoFactor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoFactor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoFactor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoFactor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string body = 3;
   */ _define_property(this, "body", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoFactor, "runtime", proto3);
_define_property(GoNoGoFactor, "typeName", "mono.datagateway.v1.GoNoGoFactor");
_define_property(GoNoGoFactor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CaptureGoNoGoDecision is the scheduled BD decision record. Outcome is
 * pending|go|defer — never no_bid / park / loss (those are P-L3e).
 *
 * @generated from message mono.datagateway.v1.CaptureGoNoGoDecision
 */ export class CaptureGoNoGoDecision extends Message {
    static fromBinary(bytes, options) {
        return new CaptureGoNoGoDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureGoNoGoDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureGoNoGoDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureGoNoGoDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GoNoGoFactor factors = 4;
   */ _define_property(this, "factors", []), /**
   * @generated from field: google.protobuf.Timestamp due_at = 5;
   */ _define_property(this, "dueAt", void 0), /**
   * pending|go|defer
   *
   * @generated from field: string outcome = 6;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 7;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureGoNoGoDecision, "runtime", proto3);
_define_property(CaptureGoNoGoDecision, "typeName", "mono.datagateway.v1.CaptureGoNoGoDecision");
_define_property(CaptureGoNoGoDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "factors",
            kind: "message",
            T: GoNoGoFactor,
            repeated: true
        },
        {
            no: 5,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureGoNoGoDecisionRequest
 */ export class UpsertCaptureGoNoGoDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureGoNoGoDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureGoNoGoDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureGoNoGoDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureGoNoGoDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureGoNoGoDecision decision = 1;
   */ _define_property(this, "decision", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureGoNoGoDecisionRequest, "runtime", proto3);
_define_property(UpsertCaptureGoNoGoDecisionRequest, "typeName", "mono.datagateway.v1.UpsertCaptureGoNoGoDecisionRequest");
_define_property(UpsertCaptureGoNoGoDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: CaptureGoNoGoDecision
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureGoNoGoDecisionResponse
 */ export class UpsertCaptureGoNoGoDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureGoNoGoDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureGoNoGoDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureGoNoGoDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureGoNoGoDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureGoNoGoDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureGoNoGoDecisionResponse, "runtime", proto3);
_define_property(UpsertCaptureGoNoGoDecisionResponse, "typeName", "mono.datagateway.v1.UpsertCaptureGoNoGoDecisionResponse");
_define_property(UpsertCaptureGoNoGoDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: CaptureGoNoGoDecision
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureGoNoGoDecisionsRequest
 */ export class ListCaptureGoNoGoDecisionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureGoNoGoDecisionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureGoNoGoDecisionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureGoNoGoDecisionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureGoNoGoDecisionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureGoNoGoDecisionsRequest, "runtime", proto3);
_define_property(ListCaptureGoNoGoDecisionsRequest, "typeName", "mono.datagateway.v1.ListCaptureGoNoGoDecisionsRequest");
_define_property(ListCaptureGoNoGoDecisionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureGoNoGoDecisionsResponse
 */ export class ListCaptureGoNoGoDecisionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureGoNoGoDecisionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureGoNoGoDecisionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureGoNoGoDecisionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureGoNoGoDecisionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureGoNoGoDecision decisions = 1;
   */ _define_property(this, "decisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureGoNoGoDecisionsResponse, "runtime", proto3);
_define_property(ListCaptureGoNoGoDecisionsResponse, "typeName", "mono.datagateway.v1.ListCaptureGoNoGoDecisionsResponse");
_define_property(ListCaptureGoNoGoDecisionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decisions",
            kind: "message",
            T: CaptureGoNoGoDecision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureProfile
 */ export class CaptureProfile extends Message {
    static fromBinary(bytes, options) {
        return new CaptureProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureProfile, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string solicitation_number = 4;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string crm_number = 5;
   */ _define_property(this, "crmNumber", ""), /**
   * @generated from field: string business_developer_id = 6;
   */ _define_property(this, "businessDeveloperId", ""), /**
   * @generated from field: string capture_manager_id = 7;
   */ _define_property(this, "captureManagerId", ""), /**
   * @generated from field: string customer_agency_names = 8;
   */ _define_property(this, "customerAgencyNames", ""), /**
   * prime|sub|jv
   *
   * @generated from field: string bid_position = 9;
   */ _define_property(this, "bidPosition", ""), /**
   * @generated from field: string vehicle = 10;
   */ _define_property(this, "vehicle", ""), /**
   * @generated from field: string procurement_type = 11;
   */ _define_property(this, "procurementType", ""), /**
   * @generated from field: string contract_type = 12;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string period_of_performance = 13;
   */ _define_property(this, "periodOfPerformance", ""), /**
   * @generated from field: string total_program_value = 14;
   */ _define_property(this, "totalProgramValue", ""), /**
   * Filter label only — not capture_projects.stage and not a kanban.
   *
   * qualifying|solutioning|pursuing|strategy|bid_review
   *
   * @generated from field: string stage_label = 15;
   */ _define_property(this, "stageLabel", ""), /**
   * @generated from field: string pwin_percent = 16;
   */ _define_property(this, "pwinPercent", ""), /**
   * @generated from field: string risks = 17;
   */ _define_property(this, "risks", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 19;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 20;
   */ _define_property(this, "deletedAt", void 0), /**
   * GRW-09: the registry vehicle (delivery.contract_vehicles, same tenant).
   * vehicle stays the free-text fallback label ("Not listed").
   *
   * @generated from field: string vehicle_id = 21;
   */ _define_property(this, "vehicleId", ""), /**
   * GRW-09: contract_vehicles.name, joined on read; ignored on write.
   *
   * @generated from field: string vehicle_label = 22;
   */ _define_property(this, "vehicleLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureProfile, "runtime", proto3);
_define_property(CaptureProfile, "typeName", "mono.datagateway.v1.CaptureProfile");
_define_property(CaptureProfile, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "crm_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "business_developer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "capture_manager_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "customer_agency_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "bid_position",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "procurement_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "period_of_performance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "total_program_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "stage_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "pwin_percent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "risks",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "vehicle_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureProfileRequest
 */ export class GetCaptureProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureProfileRequest, "runtime", proto3);
_define_property(GetCaptureProfileRequest, "typeName", "mono.datagateway.v1.GetCaptureProfileRequest");
_define_property(GetCaptureProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCaptureProfileResponse
 */ export class GetCaptureProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCaptureProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCaptureProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCaptureProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCaptureProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCaptureProfileResponse, "runtime", proto3);
_define_property(GetCaptureProfileResponse, "typeName", "mono.datagateway.v1.GetCaptureProfileResponse");
_define_property(GetCaptureProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: CaptureProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProposalBriefingSeedRequest
 */ export class GetProposalBriefingSeedRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalBriefingSeedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalBriefingSeedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalBriefingSeedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalBriefingSeedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalBriefingSeedRequest, "runtime", proto3);
_define_property(GetProposalBriefingSeedRequest, "typeName", "mono.datagateway.v1.GetProposalBriefingSeedRequest");
_define_property(GetProposalBriefingSeedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Seed values for a proposal opened from a pursuit. Empty string = unknown.
 *
 * @generated from message mono.datagateway.v1.GetProposalBriefingSeedResponse
 */ export class GetProposalBriefingSeedResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalBriefingSeedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalBriefingSeedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalBriefingSeedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalBriefingSeedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * capture_profiles.solicitation_number
   *
   * @generated from field: string solicitation_number = 1;
   */ _define_property(this, "solicitationNumber", ""), /**
   * always "" (reserved for wire compatibility; labels come from gov_org_id at read time)
   *
   * @generated from field: string agency = 2;
   */ _define_property(this, "agency", ""), /**
   * capture_projects.customer_org_id when that org exists and is not deleted
   *
   * @generated from field: string gov_org_id = 3;
   */ _define_property(this, "govOrgId", ""), /**
   * always "" (no text copy)
   *
   * @generated from field: string contract_vehicle = 4;
   */ _define_property(this, "contractVehicle", ""), /**
   * capture_profiles.vehicle_id when it is a live delivery.contract_vehicles row of the tenant; never a name match
   *
   * @generated from field: string contract_vehicle_id = 5;
   */ _define_property(this, "contractVehicleId", ""), /**
   * capture_profiles.contract_type
   *
   * @generated from field: string contract_type = 6;
   */ _define_property(this, "contractType", ""), /**
   * mapped from capture_profiles.procurement_type; "" when unmapped
   *
   * @generated from field: string set_aside = 7;
   */ _define_property(this, "setAside", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalBriefingSeedResponse, "runtime", proto3);
_define_property(GetProposalBriefingSeedResponse, "typeName", "mono.datagateway.v1.GetProposalBriefingSeedResponse");
_define_property(GetProposalBriefingSeedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "gov_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureProfileRequest
 */ export class UpsertCaptureProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureProfileRequest, "runtime", proto3);
_define_property(UpsertCaptureProfileRequest, "typeName", "mono.datagateway.v1.UpsertCaptureProfileRequest");
_define_property(UpsertCaptureProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: CaptureProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureProfileResponse
 */ export class UpsertCaptureProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProfile profile = 1;
   */ _define_property(this, "profile", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureProfileResponse, "runtime", proto3);
_define_property(UpsertCaptureProfileResponse, "typeName", "mono.datagateway.v1.UpsertCaptureProfileResponse");
_define_property(UpsertCaptureProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: CaptureProfile
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CaptureTeamingLink
 */ export class CaptureTeamingLink extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTeamingLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTeamingLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTeamingLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTeamingLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string workshare = 5;
   */ _define_property(this, "workshare", ""), /**
   * @generated from field: bool nda = 6;
   */ _define_property(this, "nda", false), /**
   * @generated from field: bool ta = 7;
   */ _define_property(this, "ta", false), /**
   * @generated from field: string rationale = 8;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTeamingLink, "runtime", proto3);
_define_property(CaptureTeamingLink, "typeName", "mono.datagateway.v1.CaptureTeamingLink");
_define_property(CaptureTeamingLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "workshare",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "nda",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "ta",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureTeamingLinkRequest
 */ export class UpsertCaptureTeamingLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureTeamingLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureTeamingLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureTeamingLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureTeamingLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureTeamingLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureTeamingLinkRequest, "runtime", proto3);
_define_property(UpsertCaptureTeamingLinkRequest, "typeName", "mono.datagateway.v1.UpsertCaptureTeamingLinkRequest");
_define_property(UpsertCaptureTeamingLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureTeamingLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureTeamingLinkResponse
 */ export class UpsertCaptureTeamingLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureTeamingLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureTeamingLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureTeamingLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureTeamingLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureTeamingLink link = 1;
   */ _define_property(this, "link", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureTeamingLinkResponse, "runtime", proto3);
_define_property(UpsertCaptureTeamingLinkResponse, "typeName", "mono.datagateway.v1.UpsertCaptureTeamingLinkResponse");
_define_property(UpsertCaptureTeamingLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureTeamingLink
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureTeamingLinksRequest
 */ export class ListCaptureTeamingLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTeamingLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTeamingLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTeamingLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTeamingLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTeamingLinksRequest, "runtime", proto3);
_define_property(ListCaptureTeamingLinksRequest, "typeName", "mono.datagateway.v1.ListCaptureTeamingLinksRequest");
_define_property(ListCaptureTeamingLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureTeamingLinksResponse
 */ export class ListCaptureTeamingLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTeamingLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTeamingLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTeamingLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTeamingLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureTeamingLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTeamingLinksResponse, "runtime", proto3);
_define_property(ListCaptureTeamingLinksResponse, "typeName", "mono.datagateway.v1.ListCaptureTeamingLinksResponse");
_define_property(ListCaptureTeamingLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CaptureTeamingLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCaptureTeamingLinkRequest
 */ export class DeleteCaptureTeamingLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureTeamingLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureTeamingLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureTeamingLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureTeamingLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureTeamingLinkRequest, "runtime", proto3);
_define_property(DeleteCaptureTeamingLinkRequest, "typeName", "mono.datagateway.v1.DeleteCaptureTeamingLinkRequest");
_define_property(DeleteCaptureTeamingLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCaptureTeamingLinkResponse
 */ export class DeleteCaptureTeamingLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureTeamingLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureTeamingLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureTeamingLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureTeamingLinkResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureTeamingLinkResponse, "runtime", proto3);
_define_property(DeleteCaptureTeamingLinkResponse, "typeName", "mono.datagateway.v1.DeleteCaptureTeamingLinkResponse");
_define_property(DeleteCaptureTeamingLinkResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.CaptureCompetitionLink
 */ export class CaptureCompetitionLink extends Message {
    static fromBinary(bytes, options) {
        return new CaptureCompetitionLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureCompetitionLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureCompetitionLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureCompetitionLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * incumbent|prime|sub
   *
   * @generated from field: string role = 5;
   */ _define_property(this, "role", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 8;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureCompetitionLink, "runtime", proto3);
_define_property(CaptureCompetitionLink, "typeName", "mono.datagateway.v1.CaptureCompetitionLink");
_define_property(CaptureCompetitionLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureCompetitionLinkRequest
 */ export class UpsertCaptureCompetitionLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureCompetitionLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureCompetitionLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureCompetitionLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureCompetitionLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureCompetitionLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureCompetitionLinkRequest, "runtime", proto3);
_define_property(UpsertCaptureCompetitionLinkRequest, "typeName", "mono.datagateway.v1.UpsertCaptureCompetitionLinkRequest");
_define_property(UpsertCaptureCompetitionLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureCompetitionLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureCompetitionLinkResponse
 */ export class UpsertCaptureCompetitionLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureCompetitionLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureCompetitionLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureCompetitionLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureCompetitionLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureCompetitionLink link = 1;
   */ _define_property(this, "link", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureCompetitionLinkResponse, "runtime", proto3);
_define_property(UpsertCaptureCompetitionLinkResponse, "typeName", "mono.datagateway.v1.UpsertCaptureCompetitionLinkResponse");
_define_property(UpsertCaptureCompetitionLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CaptureCompetitionLink
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureCompetitionLinksRequest
 */ export class ListCaptureCompetitionLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureCompetitionLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureCompetitionLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureCompetitionLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureCompetitionLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureCompetitionLinksRequest, "runtime", proto3);
_define_property(ListCaptureCompetitionLinksRequest, "typeName", "mono.datagateway.v1.ListCaptureCompetitionLinksRequest");
_define_property(ListCaptureCompetitionLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureCompetitionLinksResponse
 */ export class ListCaptureCompetitionLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureCompetitionLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureCompetitionLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureCompetitionLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureCompetitionLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureCompetitionLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureCompetitionLinksResponse, "runtime", proto3);
_define_property(ListCaptureCompetitionLinksResponse, "typeName", "mono.datagateway.v1.ListCaptureCompetitionLinksResponse");
_define_property(ListCaptureCompetitionLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CaptureCompetitionLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCaptureCompetitionLinkRequest
 */ export class DeleteCaptureCompetitionLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureCompetitionLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureCompetitionLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureCompetitionLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureCompetitionLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureCompetitionLinkRequest, "runtime", proto3);
_define_property(DeleteCaptureCompetitionLinkRequest, "typeName", "mono.datagateway.v1.DeleteCaptureCompetitionLinkRequest");
_define_property(DeleteCaptureCompetitionLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCaptureCompetitionLinkResponse
 */ export class DeleteCaptureCompetitionLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureCompetitionLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureCompetitionLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureCompetitionLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureCompetitionLinkResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureCompetitionLinkResponse, "runtime", proto3);
_define_property(DeleteCaptureCompetitionLinkResponse, "typeName", "mono.datagateway.v1.DeleteCaptureCompetitionLinkResponse");
_define_property(DeleteCaptureCompetitionLinkResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.CaptureTask
 */ export class CaptureTask extends Message {
    static fromBinary(bytes, options) {
        return new CaptureTask().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureTask().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureTask().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureTask, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * optional; not a Person registry FK
   *
   * @generated from field: string owner_user_id = 5;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 6;
   */ _define_property(this, "dueAt", void 0), /**
   * open|in_progress|done|parked
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: int32 sort_order = 9;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureTask, "runtime", proto3);
_define_property(CaptureTask, "typeName", "mono.datagateway.v1.CaptureTask");
_define_property(CaptureTask, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureTaskRequest
 */ export class UpsertCaptureTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureTask task = 1;
   */ _define_property(this, "task", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureTaskRequest, "runtime", proto3);
_define_property(UpsertCaptureTaskRequest, "typeName", "mono.datagateway.v1.UpsertCaptureTaskRequest");
_define_property(UpsertCaptureTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task",
            kind: "message",
            T: CaptureTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCaptureTaskResponse
 */ export class UpsertCaptureTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCaptureTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCaptureTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCaptureTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCaptureTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureTask task = 1;
   */ _define_property(this, "task", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCaptureTaskResponse, "runtime", proto3);
_define_property(UpsertCaptureTaskResponse, "typeName", "mono.datagateway.v1.UpsertCaptureTaskResponse");
_define_property(UpsertCaptureTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task",
            kind: "message",
            T: CaptureTask
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureTasksRequest
 */ export class ListCaptureTasksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTasksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTasksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTasksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTasksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTasksRequest, "runtime", proto3);
_define_property(ListCaptureTasksRequest, "typeName", "mono.datagateway.v1.ListCaptureTasksRequest");
_define_property(ListCaptureTasksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureTasksResponse
 */ export class ListCaptureTasksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTasksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTasksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTasksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTasksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureTask tasks = 1;
   */ _define_property(this, "tasks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTasksResponse, "runtime", proto3);
_define_property(ListCaptureTasksResponse, "typeName", "mono.datagateway.v1.ListCaptureTasksResponse");
_define_property(ListCaptureTasksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tasks",
            kind: "message",
            T: CaptureTask,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCaptureTaskRequest
 */ export class DeleteCaptureTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureTaskRequest, "runtime", proto3);
_define_property(DeleteCaptureTaskRequest, "typeName", "mono.datagateway.v1.DeleteCaptureTaskRequest");
_define_property(DeleteCaptureTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCaptureTaskResponse
 */ export class DeleteCaptureTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCaptureTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCaptureTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCaptureTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCaptureTaskResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCaptureTaskResponse, "runtime", proto3);
_define_property(DeleteCaptureTaskResponse, "typeName", "mono.datagateway.v1.DeleteCaptureTaskResponse");
_define_property(DeleteCaptureTaskResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.CapturePlanArea
 */ export class CapturePlanArea extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanArea().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanArea().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanArea().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanArea, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string lead_user_id = 5;
   */ _define_property(this, "leadUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp target_date = 6;
   */ _define_property(this, "targetDate", void 0), /**
   * @generated from field: string summary = 7;
   */ _define_property(this, "summary", ""), /**
   * not_started|in_progress|at_risk|complete|not_applicable
   *
   * @generated from field: string health = 8;
   */ _define_property(this, "health", ""), /**
   * @generated from field: string health_set_by_user_id = 9;
   */ _define_property(this, "healthSetByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp health_set_at = 10;
   */ _define_property(this, "healthSetAt", void 0), /**
   * @generated from field: int32 sort_order = 11;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanArea, "runtime", proto3);
_define_property(CapturePlanArea, "typeName", "mono.datagateway.v1.CapturePlanArea");
_define_property(CapturePlanArea, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "lead_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "health_set_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "health_set_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * CapturePlanAreaHealthEvent is one append-only ledger row. origin
 * "human" rows are decisions (applied=true, decided_by_user_id set);
 * origin "ai" rows are suggestions (applied=false, decided_by_user_id
 * unset) that never move the area's health.
 *
 * @generated from message mono.datagateway.v1.CapturePlanAreaHealthEvent
 */ export class CapturePlanAreaHealthEvent extends Message {
    static fromBinary(bytes, options) {
        return new CapturePlanAreaHealthEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapturePlanAreaHealthEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapturePlanAreaHealthEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapturePlanAreaHealthEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string area_id = 3;
   */ _define_property(this, "areaId", ""), /**
   * @generated from field: string from_health = 4;
   */ _define_property(this, "fromHealth", ""), /**
   * @generated from field: string proposed_health = 5;
   */ _define_property(this, "proposedHealth", ""), /**
   * @generated from field: string reasons = 6;
   */ _define_property(this, "reasons", ""), /**
   * human|ai
   *
   * @generated from field: string origin = 7;
   */ _define_property(this, "origin", ""), /**
   * @generated from field: string decided_by_user_id = 8;
   */ _define_property(this, "decidedByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 9;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: bool applied = 10;
   */ _define_property(this, "applied", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapturePlanAreaHealthEvent, "runtime", proto3);
_define_property(CapturePlanAreaHealthEvent, "typeName", "mono.datagateway.v1.CapturePlanAreaHealthEvent");
_define_property(CapturePlanAreaHealthEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "area_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "from_health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposed_health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "applied",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * Upsert: empty area.id creates; otherwise updates. Never moves health —
 * see RecordCapturePlanAreaHealthDecision.
 *
 * @generated from message mono.datagateway.v1.UpsertCapturePlanAreaRequest
 */ export class UpsertCapturePlanAreaRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCapturePlanAreaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCapturePlanAreaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCapturePlanAreaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCapturePlanAreaRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: mono.datagateway.v1.CapturePlanArea area = 3;
   */ _define_property(this, "area", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCapturePlanAreaRequest, "runtime", proto3);
_define_property(UpsertCapturePlanAreaRequest, "typeName", "mono.datagateway.v1.UpsertCapturePlanAreaRequest");
_define_property(UpsertCapturePlanAreaRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "area",
            kind: "message",
            T: CapturePlanArea
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCapturePlanAreaResponse
 */ export class UpsertCapturePlanAreaResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCapturePlanAreaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCapturePlanAreaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCapturePlanAreaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCapturePlanAreaResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CapturePlanArea area = 1;
   */ _define_property(this, "area", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCapturePlanAreaResponse, "runtime", proto3);
_define_property(UpsertCapturePlanAreaResponse, "typeName", "mono.datagateway.v1.UpsertCapturePlanAreaResponse");
_define_property(UpsertCapturePlanAreaResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "area",
            kind: "message",
            T: CapturePlanArea
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapturePlanAreasRequest
 */ export class ListCapturePlanAreasRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapturePlanAreasRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapturePlanAreasRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapturePlanAreasRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapturePlanAreasRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapturePlanAreasRequest, "runtime", proto3);
_define_property(ListCapturePlanAreasRequest, "typeName", "mono.datagateway.v1.ListCapturePlanAreasRequest");
_define_property(ListCapturePlanAreasRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapturePlanAreasResponse
 */ export class ListCapturePlanAreasResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapturePlanAreasResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapturePlanAreasResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapturePlanAreasResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapturePlanAreasResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapturePlanArea areas = 1;
   */ _define_property(this, "areas", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapturePlanAreasResponse, "runtime", proto3);
_define_property(ListCapturePlanAreasResponse, "typeName", "mono.datagateway.v1.ListCapturePlanAreasResponse");
_define_property(ListCapturePlanAreasResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "areas",
            kind: "message",
            T: CapturePlanArea,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCapturePlanAreaRequest
 */ export class DeleteCapturePlanAreaRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapturePlanAreaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapturePlanAreaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapturePlanAreaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapturePlanAreaRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapturePlanAreaRequest, "runtime", proto3);
_define_property(DeleteCapturePlanAreaRequest, "typeName", "mono.datagateway.v1.DeleteCapturePlanAreaRequest");
_define_property(DeleteCapturePlanAreaRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCapturePlanAreaResponse
 */ export class DeleteCapturePlanAreaResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapturePlanAreaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapturePlanAreaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapturePlanAreaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapturePlanAreaResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapturePlanAreaResponse, "runtime", proto3);
_define_property(DeleteCapturePlanAreaResponse, "typeName", "mono.datagateway.v1.DeleteCapturePlanAreaResponse");
_define_property(DeleteCapturePlanAreaResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * RecordCapturePlanAreaHealthDecision is a human decision: requires
 * decided_by_user_id and applies proposed_health to the area atomically
 * with its ledger event.
 *
 * @generated from message mono.datagateway.v1.RecordCapturePlanAreaHealthDecisionRequest
 */ export class RecordCapturePlanAreaHealthDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCapturePlanAreaHealthDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCapturePlanAreaHealthDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCapturePlanAreaHealthDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCapturePlanAreaHealthDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string area_id = 2;
   */ _define_property(this, "areaId", ""), /**
   * @generated from field: string proposed_health = 3;
   */ _define_property(this, "proposedHealth", ""), /**
   * @generated from field: string reasons = 4;
   */ _define_property(this, "reasons", ""), /**
   * @generated from field: string decided_by_user_id = 5;
   */ _define_property(this, "decidedByUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCapturePlanAreaHealthDecisionRequest, "runtime", proto3);
_define_property(RecordCapturePlanAreaHealthDecisionRequest, "typeName", "mono.datagateway.v1.RecordCapturePlanAreaHealthDecisionRequest");
_define_property(RecordCapturePlanAreaHealthDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "area_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposed_health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordCapturePlanAreaHealthDecisionResponse
 */ export class RecordCapturePlanAreaHealthDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCapturePlanAreaHealthDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCapturePlanAreaHealthDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCapturePlanAreaHealthDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCapturePlanAreaHealthDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CapturePlanArea area = 1;
   */ _define_property(this, "area", void 0), /**
   * @generated from field: mono.datagateway.v1.CapturePlanAreaHealthEvent event = 2;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCapturePlanAreaHealthDecisionResponse, "runtime", proto3);
_define_property(RecordCapturePlanAreaHealthDecisionResponse, "typeName", "mono.datagateway.v1.RecordCapturePlanAreaHealthDecisionResponse");
_define_property(RecordCapturePlanAreaHealthDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "area",
            kind: "message",
            T: CapturePlanArea
        },
        {
            no: 2,
            name: "event",
            kind: "message",
            T: CapturePlanAreaHealthEvent
        }
    ]));
/**
 * RecordCapturePlanAreaHealthSuggestion is an AI proposal: records a ledger
 * event only. It never accepts or forwards a decider, and never alters the
 * area.
 *
 * @generated from message mono.datagateway.v1.RecordCapturePlanAreaHealthSuggestionRequest
 */ export class RecordCapturePlanAreaHealthSuggestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCapturePlanAreaHealthSuggestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCapturePlanAreaHealthSuggestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCapturePlanAreaHealthSuggestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCapturePlanAreaHealthSuggestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string area_id = 2;
   */ _define_property(this, "areaId", ""), /**
   * @generated from field: string proposed_health = 3;
   */ _define_property(this, "proposedHealth", ""), /**
   * @generated from field: string reasons = 4;
   */ _define_property(this, "reasons", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCapturePlanAreaHealthSuggestionRequest, "runtime", proto3);
_define_property(RecordCapturePlanAreaHealthSuggestionRequest, "typeName", "mono.datagateway.v1.RecordCapturePlanAreaHealthSuggestionRequest");
_define_property(RecordCapturePlanAreaHealthSuggestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "area_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposed_health",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordCapturePlanAreaHealthSuggestionResponse
 */ export class RecordCapturePlanAreaHealthSuggestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCapturePlanAreaHealthSuggestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCapturePlanAreaHealthSuggestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCapturePlanAreaHealthSuggestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCapturePlanAreaHealthSuggestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CapturePlanAreaHealthEvent event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCapturePlanAreaHealthSuggestionResponse, "runtime", proto3);
_define_property(RecordCapturePlanAreaHealthSuggestionResponse, "typeName", "mono.datagateway.v1.RecordCapturePlanAreaHealthSuggestionResponse");
_define_property(RecordCapturePlanAreaHealthSuggestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: CapturePlanAreaHealthEvent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapturePlanAreaHealthEventsRequest
 */ export class ListCapturePlanAreaHealthEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapturePlanAreaHealthEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapturePlanAreaHealthEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapturePlanAreaHealthEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapturePlanAreaHealthEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string area_id = 2;
   */ _define_property(this, "areaId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapturePlanAreaHealthEventsRequest, "runtime", proto3);
_define_property(ListCapturePlanAreaHealthEventsRequest, "typeName", "mono.datagateway.v1.ListCapturePlanAreaHealthEventsRequest");
_define_property(ListCapturePlanAreaHealthEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "area_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapturePlanAreaHealthEventsResponse
 */ export class ListCapturePlanAreaHealthEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapturePlanAreaHealthEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapturePlanAreaHealthEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapturePlanAreaHealthEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapturePlanAreaHealthEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapturePlanAreaHealthEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapturePlanAreaHealthEventsResponse, "runtime", proto3);
_define_property(ListCapturePlanAreaHealthEventsResponse, "typeName", "mono.datagateway.v1.ListCapturePlanAreaHealthEventsResponse");
_define_property(ListCapturePlanAreaHealthEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: CapturePlanAreaHealthEvent,
            repeated: true
        }
    ]));
/**
 * SetCaptureTaskPlanArea links (or, with empty area_id, unlinks) one
 * capture task to a Capture Plan area.
 *
 * @generated from message mono.datagateway.v1.SetCaptureTaskPlanAreaRequest
 */ export class SetCaptureTaskPlanAreaRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTaskPlanAreaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTaskPlanAreaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTaskPlanAreaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTaskPlanAreaRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string task_id = 3;
   */ _define_property(this, "taskId", ""), /**
   * @generated from field: string area_id = 4;
   */ _define_property(this, "areaId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTaskPlanAreaRequest, "runtime", proto3);
_define_property(SetCaptureTaskPlanAreaRequest, "typeName", "mono.datagateway.v1.SetCaptureTaskPlanAreaRequest");
_define_property(SetCaptureTaskPlanAreaRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "area_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetCaptureTaskPlanAreaResponse
 */ export class SetCaptureTaskPlanAreaResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCaptureTaskPlanAreaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCaptureTaskPlanAreaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCaptureTaskPlanAreaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCaptureTaskPlanAreaResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCaptureTaskPlanAreaResponse, "runtime", proto3);
_define_property(SetCaptureTaskPlanAreaResponse, "typeName", "mono.datagateway.v1.SetCaptureTaskPlanAreaResponse");
_define_property(SetCaptureTaskPlanAreaResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * ListCaptureTaskPlanAreaLinks returns every linked task -> area pairing
 * for the projection: task_id -> capture_plan_area_id.
 *
 * @generated from message mono.datagateway.v1.ListCaptureTaskPlanAreaLinksRequest
 */ export class ListCaptureTaskPlanAreaLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTaskPlanAreaLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTaskPlanAreaLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTaskPlanAreaLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTaskPlanAreaLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTaskPlanAreaLinksRequest, "runtime", proto3);
_define_property(ListCaptureTaskPlanAreaLinksRequest, "typeName", "mono.datagateway.v1.ListCaptureTaskPlanAreaLinksRequest");
_define_property(ListCaptureTaskPlanAreaLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureTaskPlanAreaLinksResponse
 */ export class ListCaptureTaskPlanAreaLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureTaskPlanAreaLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureTaskPlanAreaLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureTaskPlanAreaLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureTaskPlanAreaLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: map<string, string> task_area_links = 1;
   */ _define_property(this, "taskAreaLinks", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureTaskPlanAreaLinksResponse, "runtime", proto3);
_define_property(ListCaptureTaskPlanAreaLinksResponse, "typeName", "mono.datagateway.v1.ListCaptureTaskPlanAreaLinksResponse");
_define_property(ListCaptureTaskPlanAreaLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_area_links",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GrowthValueProvenance
 */ export class GrowthValueProvenance extends Message {
    static fromBinary(bytes, options) {
        return new GrowthValueProvenance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthValueProvenance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthValueProvenance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthValueProvenance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * Target triple: the canonical record/field this value is attached to.
   * Growth never recreates the canonical record here (C-GOV-01).
   *
   * @generated from field: string target_object_type = 3;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 4;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string target_field_path = 5;
   */ _define_property(this, "targetFieldPath", ""), /**
   * Which of the four transfer patterns (C-LIFE-01), and who owns the value
   * now (for adopted content, the receiving workspace).
   *
   * live_authorized_reference|adopted_working_content|frozen_snapshot|released_reusable_evidence
   *
   * @generated from field: string transfer_mode = 6;
   */ _define_property(this, "transferMode", ""), /**
   * @generated from field: string owning_workspace_id = 7;
   */ _define_property(this, "owningWorkspaceId", ""), /**
   * Source identity. source_version is PINNED at transfer time for
   * adopted/frozen rows; unset for live references, which have no pinned
   * version by definition.
   *
   * @generated from field: string source_object_type = 8;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string source_object_id = 9;
   */ _define_property(this, "sourceObjectId", ""), /**
   * @generated from field: string source_field_path = 10;
   */ _define_property(this, "sourceFieldPath", ""), /**
   * @generated from field: string source_record_id = 11;
   */ _define_property(this, "sourceRecordId", ""), /**
   * @generated from field: int32 source_version = 12;
   */ _define_property(this, "sourceVersion", 0), /**
   * Version identity (C-GOV-09): at most one current row per (target,
   * transfer_mode) is enforced by a DB partial unique index, not a
   * read-then-write race in application code.
   *
   * @generated from field: int32 version = 13;
   */ _define_property(this, "version", 0), /**
   * @generated from field: bool current_version_flag = 14;
   */ _define_property(this, "currentVersionFlag", false), /**
   * @generated from field: string superseded_by_id = 15;
   */ _define_property(this, "supersededById", ""), /**
   * value_json / value_state (C-GOV-03) are deliberately two fields, not
   * one optional field: a missing value, a known zero and a known
   * not-applicable value must stay three distinct persisted states, and a
   * proto3 scalar cannot carry that distinction on its own. Do not
   * "simplify" these into a single field — that silently destroys C-GOV-03.
   *
   * @generated from field: string value_json = 16;
   */ _define_property(this, "valueJson", ""), /**
   * known|unknown|not_applicable. See value_json above for why this is a
   * separate field rather than folded into it.
   *
   * @generated from field: string value_state = 17;
   */ _define_property(this, "valueState", ""), /**
   * D2 source locations, copied verbatim from delivery.SourceReference so
   * precise page/bounding-box/file-location provenance survives acceptance,
   * not just extraction.
   *
   * @generated from field: string source_artifact_id = 18;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: string source_artifact_version_id = 19;
   */ _define_property(this, "sourceArtifactVersionId", ""), /**
   * @generated from field: string source_content_sha256 = 20;
   */ _define_property(this, "sourceContentSha256", ""), /**
   * @generated from field: string source_block_id = 21;
   */ _define_property(this, "sourceBlockId", ""), /**
   * @generated from field: string source_span = 22;
   */ _define_property(this, "sourceSpan", ""), /**
   * @generated from field: int32 source_page = 23;
   */ _define_property(this, "sourcePage", 0), /**
   * @generated from field: string source_section = 24;
   */ _define_property(this, "sourceSection", ""), /**
   * @generated from field: string source_quote = 25;
   */ _define_property(this, "sourceQuote", ""), /**
   * Review of a later source change (C-LIFE-03): a source change sets
   * these; it never mutates value_json.
   *
   * current|source_changed|reviewed
   *
   * @generated from field: string review_state = 26;
   */ _define_property(this, "reviewState", ""), /**
   * @generated from field: google.protobuf.Timestamp flagged_at = 27;
   */ _define_property(this, "flaggedAt", void 0), /**
   * @generated from field: int32 flagged_source_version = 28;
   */ _define_property(this, "flaggedSourceVersion", 0), /**
   * Release/authorization for released_reusable_evidence (C-LIFE-01,
   * C-LIFE-04): the explicit internal audience it was bounded to.
   *
   * not_released|released
   *
   * @generated from field: string release_state = 29;
   */ _define_property(this, "releaseState", ""), /**
   * @generated from field: string released_by = 30;
   */ _define_property(this, "releasedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp released_at = 31;
   */ _define_property(this, "releasedAt", void 0), /**
   * @generated from field: string release_audience = 32;
   */ _define_property(this, "releaseAudience", ""), /**
   * Retry identity (C-LIFE-05): an unchanged reimport upserts against this
   * key instead of minting a new row / new business event.
   *
   * @generated from field: string import_idempotency_key = 33;
   */ _define_property(this, "importIdempotencyKey", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 34;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 35;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 36;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string updated_by = 37;
   */ _define_property(this, "updatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 38;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthValueProvenance, "runtime", proto3);
_define_property(GrowthValueProvenance, "typeName", "mono.datagateway.v1.GrowthValueProvenance");
_define_property(GrowthValueProvenance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "transfer_mode",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "owning_workspace_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "current_version_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "value_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "source_artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "source_content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "source_block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "source_span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 24,
            name: "source_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "source_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "review_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "flagged_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 28,
            name: "flagged_source_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 29,
            name: "release_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "released_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "released_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 32,
            name: "release_audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "import_idempotency_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 35,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 36,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 37,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * GrowthProvenanceEvent is the append-only business-event ledger for a
 * GrowthValueProvenance row: proves an unchanged re-import creates no
 * second business event by row count (C-LIFE-05).
 *
 * @generated from message mono.datagateway.v1.GrowthProvenanceEvent
 */ export class GrowthProvenanceEvent extends Message {
    static fromBinary(bytes, options) {
        return new GrowthProvenanceEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthProvenanceEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthProvenanceEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthProvenanceEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string provenance_record_id = 3;
   */ _define_property(this, "provenanceRecordId", ""), /**
   * recorded|adopted|frozen|released|source_changed|superseded
   *
   * @generated from field: string event_type = 4;
   */ _define_property(this, "eventType", ""), /**
   * @generated from field: string actor_user_id = 5;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string payload_json = 6;
   */ _define_property(this, "payloadJson", ""), /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 7;
   */ _define_property(this, "occurredAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthProvenanceEvent, "runtime", proto3);
_define_property(GrowthProvenanceEvent, "typeName", "mono.datagateway.v1.GrowthProvenanceEvent");
_define_property(GrowthProvenanceEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "event_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "payload_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "occurred_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * --- Record ---
 * Record creates a new provenance row, idempotent on
 * record.import_idempotency_key (required): a retry with the same key and
 * an unchanged target mints no second row and appends no second "recorded"
 * event — created=false makes that observable over the wire, not just in
 * the database (C-LIFE-05).
 *
 * @generated from message mono.datagateway.v1.RecordGrowthValueProvenanceRequest
 */ export class RecordGrowthValueProvenanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordGrowthValueProvenanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordGrowthValueProvenanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordGrowthValueProvenanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordGrowthValueProvenanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthValueProvenance record = 1;
   */ _define_property(this, "record", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordGrowthValueProvenanceRequest, "runtime", proto3);
_define_property(RecordGrowthValueProvenanceRequest, "typeName", "mono.datagateway.v1.RecordGrowthValueProvenanceRequest");
_define_property(RecordGrowthValueProvenanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GrowthValueProvenance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordGrowthValueProvenanceResponse
 */ export class RecordGrowthValueProvenanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordGrowthValueProvenanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordGrowthValueProvenanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordGrowthValueProvenanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordGrowthValueProvenanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthValueProvenance record = 1;
   */ _define_property(this, "record", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordGrowthValueProvenanceResponse, "runtime", proto3);
_define_property(RecordGrowthValueProvenanceResponse, "typeName", "mono.datagateway.v1.RecordGrowthValueProvenanceResponse");
_define_property(RecordGrowthValueProvenanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GrowthValueProvenance
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * --- Adopt ---
 * Adopt creates an adopted_working_content row: a deliberate starting copy
 * of record.source_record_id, now owned by record.owning_workspace_id. The
 * server pins source_version and copies D2 source-location fields verbatim
 * at adoption time (C-LIFE-01).
 *
 * @generated from message mono.datagateway.v1.AdoptGrowthValueRequest
 */ export class AdoptGrowthValueRequest extends Message {
    static fromBinary(bytes, options) {
        return new AdoptGrowthValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptGrowthValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptGrowthValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptGrowthValueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthValueProvenance record = 1;
   */ _define_property(this, "record", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptGrowthValueRequest, "runtime", proto3);
_define_property(AdoptGrowthValueRequest, "typeName", "mono.datagateway.v1.AdoptGrowthValueRequest");
_define_property(AdoptGrowthValueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GrowthValueProvenance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AdoptGrowthValueResponse
 */ export class AdoptGrowthValueResponse extends Message {
    static fromBinary(bytes, options) {
        return new AdoptGrowthValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdoptGrowthValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdoptGrowthValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AdoptGrowthValueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthValueProvenance record = 1;
   */ _define_property(this, "record", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AdoptGrowthValueResponse, "runtime", proto3);
_define_property(AdoptGrowthValueResponse, "typeName", "mono.datagateway.v1.AdoptGrowthValueResponse");
_define_property(AdoptGrowthValueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GrowthValueProvenance
        }
    ]));
/**
 * --- Freeze ---
 * Freeze records a frozen_snapshot for the target triple in record. A new
 * version is a NEW row; the prior current row is superseded, never mutated
 * (C-GOV-09, C-LIFE-01).
 *
 * @generated from message mono.datagateway.v1.FreezeGrowthSnapshotRequest
 */ export class FreezeGrowthSnapshotRequest extends Message {
    static fromBinary(bytes, options) {
        return new FreezeGrowthSnapshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FreezeGrowthSnapshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FreezeGrowthSnapshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FreezeGrowthSnapshotRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthValueProvenance record = 1;
   */ _define_property(this, "record", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FreezeGrowthSnapshotRequest, "runtime", proto3);
_define_property(FreezeGrowthSnapshotRequest, "typeName", "mono.datagateway.v1.FreezeGrowthSnapshotRequest");
_define_property(FreezeGrowthSnapshotRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GrowthValueProvenance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FreezeGrowthSnapshotResponse
 */ export class FreezeGrowthSnapshotResponse extends Message {
    static fromBinary(bytes, options) {
        return new FreezeGrowthSnapshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FreezeGrowthSnapshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FreezeGrowthSnapshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FreezeGrowthSnapshotResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthValueProvenance record = 1;
   */ _define_property(this, "record", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FreezeGrowthSnapshotResponse, "runtime", proto3);
_define_property(FreezeGrowthSnapshotResponse, "typeName", "mono.datagateway.v1.FreezeGrowthSnapshotResponse");
_define_property(FreezeGrowthSnapshotResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GrowthValueProvenance
        }
    ]));
/**
 * --- Release ---
 * GrowthReleaseGrant is a deliberate, explicit release authorization —
 * released_by + release_audience — carried as its own request field rather
 * than being inferred from the caller's edit access. Release authority is
 * never implied by edit access (C-LIFE-01 required regression); see
 * ReleaseAuthority / NewReleaseGrant in
 * services/pangaea/pkg/repository/govcon_provenance_repository.go.
 *
 * @generated from message mono.datagateway.v1.GrowthReleaseGrant
 */ export class GrowthReleaseGrant extends Message {
    static fromBinary(bytes, options) {
        return new GrowthReleaseGrant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthReleaseGrant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthReleaseGrant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthReleaseGrant, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string released_by = 1;
   */ _define_property(this, "releasedBy", ""), /**
   * @generated from field: string release_audience = 2;
   */ _define_property(this, "releaseAudience", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthReleaseGrant, "runtime", proto3);
_define_property(GrowthReleaseGrant, "typeName", "mono.datagateway.v1.GrowthReleaseGrant");
_define_property(GrowthReleaseGrant, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "released_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "release_audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReleaseGrowthEvidenceRequest
 */ export class ReleaseGrowthEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReleaseGrowthEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReleaseGrowthEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReleaseGrowthEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReleaseGrowthEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * id of the existing released_reusable_evidence row to release.
   *
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.GrowthReleaseGrant grant = 3;
   */ _define_property(this, "grant", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReleaseGrowthEvidenceRequest, "runtime", proto3);
_define_property(ReleaseGrowthEvidenceRequest, "typeName", "mono.datagateway.v1.ReleaseGrowthEvidenceRequest");
_define_property(ReleaseGrowthEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "grant",
            kind: "message",
            T: GrowthReleaseGrant
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReleaseGrowthEvidenceResponse
 */ export class ReleaseGrowthEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReleaseGrowthEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReleaseGrowthEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReleaseGrowthEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReleaseGrowthEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthValueProvenance record = 1;
   */ _define_property(this, "record", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReleaseGrowthEvidenceResponse, "runtime", proto3);
_define_property(ReleaseGrowthEvidenceResponse, "typeName", "mono.datagateway.v1.ReleaseGrowthEvidenceResponse");
_define_property(ReleaseGrowthEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GrowthValueProvenance
        }
    ]));
/**
 * --- ApplySourceChange ---
 * Flags (never rewrites) every live_authorized_reference row dependent on
 * the given source triple; adopted_working_content and frozen_snapshot rows
 * for the same source are untouched — they preserve their pinned version
 * and content by definition (C-LIFE-03).
 *
 * @generated from message mono.datagateway.v1.ApplySourceChangeRequest
 */ export class ApplySourceChangeRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplySourceChangeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplySourceChangeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplySourceChangeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplySourceChangeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string source_object_type = 2;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string source_object_id = 3;
   */ _define_property(this, "sourceObjectId", ""), /**
   * @generated from field: string source_field_path = 4;
   */ _define_property(this, "sourceFieldPath", ""), /**
   * @generated from field: int32 new_source_version = 5;
   */ _define_property(this, "newSourceVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplySourceChangeRequest, "runtime", proto3);
_define_property(ApplySourceChangeRequest, "typeName", "mono.datagateway.v1.ApplySourceChangeRequest");
_define_property(ApplySourceChangeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "new_source_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApplySourceChangeResponse
 */ export class ApplySourceChangeResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplySourceChangeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplySourceChangeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplySourceChangeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplySourceChangeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 flagged_count = 1;
   */ _define_property(this, "flaggedCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplySourceChangeResponse, "runtime", proto3);
_define_property(ApplySourceChangeResponse, "typeName", "mono.datagateway.v1.ApplySourceChangeResponse");
_define_property(ApplySourceChangeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "flagged_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * --- GetGrowthValueProvenance ---
 *
 * @generated from message mono.datagateway.v1.GetGrowthValueProvenanceRequest
 */ export class GetGrowthValueProvenanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGrowthValueProvenanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGrowthValueProvenanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGrowthValueProvenanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGrowthValueProvenanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGrowthValueProvenanceRequest, "runtime", proto3);
_define_property(GetGrowthValueProvenanceRequest, "typeName", "mono.datagateway.v1.GetGrowthValueProvenanceRequest");
_define_property(GetGrowthValueProvenanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetGrowthValueProvenanceResponse
 */ export class GetGrowthValueProvenanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGrowthValueProvenanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGrowthValueProvenanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGrowthValueProvenanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGrowthValueProvenanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthValueProvenance record = 1;
   */ _define_property(this, "record", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGrowthValueProvenanceResponse, "runtime", proto3);
_define_property(GetGrowthValueProvenanceResponse, "typeName", "mono.datagateway.v1.GetGrowthValueProvenanceResponse");
_define_property(GetGrowthValueProvenanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GrowthValueProvenance
        }
    ]));
/**
 * --- ListGrowthValueProvenance ---
 *
 * @generated from message mono.datagateway.v1.ListGrowthValueProvenanceRequest
 */ export class ListGrowthValueProvenanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthValueProvenanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthValueProvenanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthValueProvenanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthValueProvenanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string target_object_type = 2;
   */ _define_property(this, "targetObjectType", ""), /**
   * @generated from field: string target_object_id = 3;
   */ _define_property(this, "targetObjectId", ""), /**
   * @generated from field: string target_field_path = 4;
   */ _define_property(this, "targetFieldPath", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthValueProvenanceRequest, "runtime", proto3);
_define_property(ListGrowthValueProvenanceRequest, "typeName", "mono.datagateway.v1.ListGrowthValueProvenanceRequest");
_define_property(ListGrowthValueProvenanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGrowthValueProvenanceResponse
 */ export class ListGrowthValueProvenanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthValueProvenanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthValueProvenanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthValueProvenanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthValueProvenanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GrowthValueProvenance records = 1;
   */ _define_property(this, "records", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthValueProvenanceResponse, "runtime", proto3);
_define_property(ListGrowthValueProvenanceResponse, "typeName", "mono.datagateway.v1.ListGrowthValueProvenanceResponse");
_define_property(ListGrowthValueProvenanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "records",
            kind: "message",
            T: GrowthValueProvenance,
            repeated: true
        }
    ]));
/**
 * --- ListGrowthProvenanceEvents ---
 *
 * @generated from message mono.datagateway.v1.ListGrowthProvenanceEventsRequest
 */ export class ListGrowthProvenanceEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthProvenanceEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthProvenanceEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthProvenanceEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthProvenanceEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string provenance_record_id = 2;
   */ _define_property(this, "provenanceRecordId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthProvenanceEventsRequest, "runtime", proto3);
_define_property(ListGrowthProvenanceEventsRequest, "typeName", "mono.datagateway.v1.ListGrowthProvenanceEventsRequest");
_define_property(ListGrowthProvenanceEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGrowthProvenanceEventsResponse
 */ export class ListGrowthProvenanceEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthProvenanceEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthProvenanceEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthProvenanceEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthProvenanceEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GrowthProvenanceEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthProvenanceEventsResponse, "runtime", proto3);
_define_property(ListGrowthProvenanceEventsResponse, "typeName", "mono.datagateway.v1.ListGrowthProvenanceEventsResponse");
_define_property(ListGrowthProvenanceEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: GrowthProvenanceEvent,
            repeated: true
        }
    ]));
/**
 * CompetitiveFieldParticipant is a Company in the pursuit's competitive
 * field and the basis for including them. Distinct from
 * CaptureCompetitionLink (company + incumbent|prime|sub role) — this is the
 * evidence-backed field, not the SoR for the current incumbent.
 *
 * @generated from message mono.datagateway.v1.CompetitiveFieldParticipant
 */ export class CompetitiveFieldParticipant extends Message {
    static fromBinary(bytes, options) {
        return new CompetitiveFieldParticipant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitiveFieldParticipant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitiveFieldParticipant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitiveFieldParticipant, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * incumbent|prior_award|capability_match|market_signal|customer_mention|teaming_signal
   *
   * @generated from field: string inclusion_basis = 5;
   */ _define_property(this, "inclusionBasis", ""), /**
   * @generated from field: string basis_note = 6;
   */ _define_property(this, "basisNote", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 9;
   */ _define_property(this, "deletedAt", void 0), /**
   * GRW-08: the role we expect this competitor to bid in: prime|sub|jv|unknown.
   *
   * @generated from field: string expected_role = 10;
   */ _define_property(this, "expectedRole", ""), /**
   * GRW-08: provenance when created from a legacy competition link.
   *
   * @generated from field: string migrated_from_competition_link_id = 11;
   */ _define_property(this, "migratedFromCompetitionLinkId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitiveFieldParticipant, "runtime", proto3);
_define_property(CompetitiveFieldParticipant, "typeName", "mono.datagateway.v1.CompetitiveFieldParticipant");
_define_property(CompetitiveFieldParticipant, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "inclusion_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "basis_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "expected_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "migrated_from_competition_link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CompetitiveFieldAssessment is our current qualitative likelihood/
 * confidence belief about one participant's bid intent. Revised by new row,
 * never updated in place: supersedes_id + superseded_at chain a revision to
 * its predecessor. At most one live (superseded_at unset) row per
 * participant.
 *
 * No numeric price or rate field appears here (B3.4-08) — likelihood_band,
 * assertion_status and confidence are qualitative strings matching the
 * migration's CHECK enums.
 *
 * @generated from message mono.datagateway.v1.CompetitiveFieldAssessment
 */ export class CompetitiveFieldAssessment extends Message {
    static fromBinary(bytes, options) {
        return new CompetitiveFieldAssessment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitiveFieldAssessment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitiveFieldAssessment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitiveFieldAssessment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string participant_id = 3;
   */ _define_property(this, "participantId", ""), /**
   * possible|likely|confirmed
   *
   * @generated from field: string likelihood_band = 4;
   */ _define_property(this, "likelihoodBand", ""), /**
   * hypothesis|corroborated|established
   *
   * @generated from field: string assertion_status = 5;
   */ _define_property(this, "assertionStatus", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 6;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: google.protobuf.Timestamp as_of_date = 8;
   */ _define_property(this, "asOfDate", void 0), /**
   * @generated from field: string supersedes_id = 9;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: google.protobuf.Timestamp superseded_at = 10;
   */ _define_property(this, "supersededAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 13;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitiveFieldAssessment, "runtime", proto3);
_define_property(CompetitiveFieldAssessment, "typeName", "mono.datagateway.v1.CompetitiveFieldAssessment");
_define_property(CompetitiveFieldAssessment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "likelihood_band",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "assertion_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "as_of_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "superseded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * CompetitiveFieldStrategy is OUR proposed positioning, discriminators and
 * response to one participant. Held separately from participation and
 * likelihood so a strategy edit never touches evidence or the assessment
 * chain.
 *
 * @generated from message mono.datagateway.v1.CompetitiveFieldStrategy
 */ export class CompetitiveFieldStrategy extends Message {
    static fromBinary(bytes, options) {
        return new CompetitiveFieldStrategy().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitiveFieldStrategy().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitiveFieldStrategy().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitiveFieldStrategy, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 4;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string positioning = 5;
   */ _define_property(this, "positioning", ""), /**
   * @generated from field: string discriminators = 6;
   */ _define_property(this, "discriminators", ""), /**
   * @generated from field: string response = 7;
   */ _define_property(this, "response", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 10;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitiveFieldStrategy, "runtime", proto3);
_define_property(CompetitiveFieldStrategy, "typeName", "mono.datagateway.v1.CompetitiveFieldStrategy");
_define_property(CompetitiveFieldStrategy, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "positioning",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "discriminators",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "response",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * CompetitorEvidence is an append-only source record supporting or
 * contradicting a participant's assessment. No delete/update RPC — a
 * correction or contradiction is always a new row; supersedes_evidence_id
 * links it back without erasing what it revises.
 *
 * B3.4-09.3: a derived numeric claim (e.g. an award/contract value read as
 * an hourly rate) travels only as claim_type = "rate_or_price_inference"
 * plus non-empty inference_assumptions below — never as a bare numeric
 * field. No numeric price/rate field exists anywhere in this file (B3.4-08).
 *
 * @generated from message mono.datagateway.v1.CompetitorEvidence
 */ export class CompetitorEvidence extends Message {
    static fromBinary(bytes, options) {
        return new CompetitorEvidence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitorEvidence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitorEvidence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitorEvidence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string participant_id = 3;
   */ _define_property(this, "participantId", ""), /**
   * rate_sheet|public_award|web_reference|internal_observation|manual_entry
   *
   * @generated from field: string source_kind = 4;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 5;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: google.protobuf.Timestamp source_date = 6;
   */ _define_property(this, "sourceDate", void 0), /**
   * strength|vulnerability|customer_position|likely_strategy|capability|rate_or_price_inference|pricing_posture|other
   *
   * @generated from field: string claim_type = 7;
   */ _define_property(this, "claimType", ""), /**
   * supports|contradicts
   *
   * @generated from field: string stance = 8;
   */ _define_property(this, "stance", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 9;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 10;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string inference_assumptions = 11;
   */ _define_property(this, "inferenceAssumptions", ""), /**
   * @generated from field: string supersedes_evidence_id = 12;
   */ _define_property(this, "supersedesEvidenceId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * evidenced (source_ref + source_date required) | assumption (rationale
   * required). An assumption is never presented as sourced fact.
   *
   * @generated from field: string basis = 14;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string actor_user_id = 15;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitorEvidence, "runtime", proto3);
_define_property(CompetitorEvidence, "typeName", "mono.datagateway.v1.CompetitorEvidence");
_define_property(CompetitorEvidence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "claim_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "stance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "inference_assumptions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "supersedes_evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * BlackHatInput is qualitative Black Hat prep for a pursuit (optionally
 * scoped to one participant). Deliberately has no numeric price/rate field
 * — see B3.4-08 / B3.4-09.3 above and the migration 000196 header.
 *
 * @generated from message mono.datagateway.v1.BlackHatInput
 */ export class BlackHatInput extends Message {
    static fromBinary(bytes, options) {
        return new BlackHatInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BlackHatInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BlackHatInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BlackHatInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 4;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string competitor_advantages = 5;
   */ _define_property(this, "competitorAdvantages", ""), /**
   * @generated from field: string competitor_vulnerabilities = 6;
   */ _define_property(this, "competitorVulnerabilities", ""), /**
   * @generated from field: string likely_approaches = 7;
   */ _define_property(this, "likelyApproaches", ""), /**
   * @generated from field: string our_response = 8;
   */ _define_property(this, "ourResponse", ""), /**
   * @generated from field: string open_questions = 9;
   */ _define_property(this, "openQuestions", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0), /**
   * Attribution and history: an edit is a new row superseding its predecessor.
   *
   * @generated from field: string actor_user_id = 13;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string supersedes_id = 14;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: google.protobuf.Timestamp superseded_at = 15;
   */ _define_property(this, "supersededAt", void 0), /**
   * Human review stamp; unset until a person reviews this exact content.
   *
   * @generated from field: string reviewed_by = 16;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 17;
   */ _define_property(this, "reviewedAt", void 0), /**
   * @generated from field: string review_note = 18;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BlackHatInput, "runtime", proto3);
_define_property(BlackHatInput, "typeName", "mono.datagateway.v1.BlackHatInput");
_define_property(BlackHatInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "competitor_advantages",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "competitor_vulnerabilities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "likely_approaches",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "our_response",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "open_questions",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "superseded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CompetitiveFieldParticipantView is one row of the GetCompetitiveField
 * aggregate read: a participant with its current (live, non-superseded)
 * assessment, its evidence list and its strategy. current_assessment and
 * strategy are unset when none has been recorded yet.
 *
 * @generated from message mono.datagateway.v1.CompetitiveFieldParticipantView
 */ export class CompetitiveFieldParticipantView extends Message {
    static fromBinary(bytes, options) {
        return new CompetitiveFieldParticipantView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompetitiveFieldParticipantView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompetitiveFieldParticipantView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompetitiveFieldParticipantView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldParticipant participant = 1;
   */ _define_property(this, "participant", void 0), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldAssessment current_assessment = 2;
   */ _define_property(this, "currentAssessment", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CompetitorEvidence evidence = 3;
   */ _define_property(this, "evidence", []), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldStrategy strategy = 4;
   */ _define_property(this, "strategy", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompetitiveFieldParticipantView, "runtime", proto3);
_define_property(CompetitiveFieldParticipantView, "typeName", "mono.datagateway.v1.CompetitiveFieldParticipantView");
_define_property(CompetitiveFieldParticipantView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant",
            kind: "message",
            T: CompetitiveFieldParticipant
        },
        {
            no: 2,
            name: "current_assessment",
            kind: "message",
            T: CompetitiveFieldAssessment
        },
        {
            no: 3,
            name: "evidence",
            kind: "message",
            T: CompetitorEvidence,
            repeated: true
        },
        {
            no: 4,
            name: "strategy",
            kind: "message",
            T: CompetitiveFieldStrategy
        }
    ]));
/**
 * GetCompetitiveField is the single aggregate read the UI uses: every
 * participant in the field plus the pursuit's Black Hat inputs.
 *
 * @generated from message mono.datagateway.v1.GetCompetitiveFieldRequest
 */ export class GetCompetitiveFieldRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCompetitiveFieldRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompetitiveFieldRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompetitiveFieldRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompetitiveFieldRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompetitiveFieldRequest, "runtime", proto3);
_define_property(GetCompetitiveFieldRequest, "typeName", "mono.datagateway.v1.GetCompetitiveFieldRequest");
_define_property(GetCompetitiveFieldRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCompetitiveFieldResponse
 */ export class GetCompetitiveFieldResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCompetitiveFieldResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompetitiveFieldResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompetitiveFieldResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompetitiveFieldResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CompetitiveFieldParticipantView participants = 1;
   */ _define_property(this, "participants", []), /**
   * @generated from field: repeated mono.datagateway.v1.BlackHatInput black_hat_inputs = 2;
   */ _define_property(this, "blackHatInputs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompetitiveFieldResponse, "runtime", proto3);
_define_property(GetCompetitiveFieldResponse, "typeName", "mono.datagateway.v1.GetCompetitiveFieldResponse");
_define_property(GetCompetitiveFieldResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participants",
            kind: "message",
            T: CompetitiveFieldParticipantView,
            repeated: true
        },
        {
            no: 2,
            name: "black_hat_inputs",
            kind: "message",
            T: BlackHatInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCompetitiveFieldParticipantRequest
 */ export class UpsertCompetitiveFieldParticipantRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompetitiveFieldParticipantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompetitiveFieldParticipantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompetitiveFieldParticipantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompetitiveFieldParticipantRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldParticipant participant = 1;
   */ _define_property(this, "participant", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompetitiveFieldParticipantRequest, "runtime", proto3);
_define_property(UpsertCompetitiveFieldParticipantRequest, "typeName", "mono.datagateway.v1.UpsertCompetitiveFieldParticipantRequest");
_define_property(UpsertCompetitiveFieldParticipantRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant",
            kind: "message",
            T: CompetitiveFieldParticipant
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCompetitiveFieldParticipantResponse
 */ export class UpsertCompetitiveFieldParticipantResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompetitiveFieldParticipantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompetitiveFieldParticipantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompetitiveFieldParticipantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompetitiveFieldParticipantResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldParticipant participant = 1;
   */ _define_property(this, "participant", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompetitiveFieldParticipantResponse, "runtime", proto3);
_define_property(UpsertCompetitiveFieldParticipantResponse, "typeName", "mono.datagateway.v1.UpsertCompetitiveFieldParticipantResponse");
_define_property(UpsertCompetitiveFieldParticipantResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant",
            kind: "message",
            T: CompetitiveFieldParticipant
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCompetitiveFieldParticipantRequest
 */ export class DeleteCompetitiveFieldParticipantRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompetitiveFieldParticipantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompetitiveFieldParticipantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompetitiveFieldParticipantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompetitiveFieldParticipantRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompetitiveFieldParticipantRequest, "runtime", proto3);
_define_property(DeleteCompetitiveFieldParticipantRequest, "typeName", "mono.datagateway.v1.DeleteCompetitiveFieldParticipantRequest");
_define_property(DeleteCompetitiveFieldParticipantRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCompetitiveFieldParticipantResponse
 */ export class DeleteCompetitiveFieldParticipantResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompetitiveFieldParticipantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompetitiveFieldParticipantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompetitiveFieldParticipantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompetitiveFieldParticipantResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompetitiveFieldParticipantResponse, "runtime", proto3);
_define_property(DeleteCompetitiveFieldParticipantResponse, "typeName", "mono.datagateway.v1.DeleteCompetitiveFieldParticipantResponse");
_define_property(DeleteCompetitiveFieldParticipantResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * GRW-08 (SAD-1136).
 *
 * @generated from message mono.datagateway.v1.ReplaceIncumbentParticipantRequest
 */ export class ReplaceIncumbentParticipantRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReplaceIncumbentParticipantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReplaceIncumbentParticipantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReplaceIncumbentParticipantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReplaceIncumbentParticipantRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * empty: just make the company the incumbent
   *
   * @generated from field: string old_participant_id = 3;
   */ _define_property(this, "oldParticipantId", ""), /**
   * @generated from field: string new_company_profile_id = 4;
   */ _define_property(this, "newCompanyProfileId", ""), /**
   * @generated from field: string actor = 5;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReplaceIncumbentParticipantRequest, "runtime", proto3);
_define_property(ReplaceIncumbentParticipantRequest, "typeName", "mono.datagateway.v1.ReplaceIncumbentParticipantRequest");
_define_property(ReplaceIncumbentParticipantRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "old_participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "new_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReplaceIncumbentParticipantResponse
 */ export class ReplaceIncumbentParticipantResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReplaceIncumbentParticipantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReplaceIncumbentParticipantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReplaceIncumbentParticipantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReplaceIncumbentParticipantResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldParticipant participant = 1;
   */ _define_property(this, "participant", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReplaceIncumbentParticipantResponse, "runtime", proto3);
_define_property(ReplaceIncumbentParticipantResponse, "typeName", "mono.datagateway.v1.ReplaceIncumbentParticipantResponse");
_define_property(ReplaceIncumbentParticipantResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant",
            kind: "message",
            T: CompetitiveFieldParticipant
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetCompetitionParticipantRoleRequest
 */ export class SetCompetitionParticipantRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetCompetitionParticipantRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCompetitionParticipantRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCompetitionParticipantRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCompetitionParticipantRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * incumbent|prime|sub
   *
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string actor = 5;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCompetitionParticipantRoleRequest, "runtime", proto3);
_define_property(SetCompetitionParticipantRoleRequest, "typeName", "mono.datagateway.v1.SetCompetitionParticipantRoleRequest");
_define_property(SetCompetitionParticipantRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetCompetitionParticipantRoleResponse
 */ export class SetCompetitionParticipantRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetCompetitionParticipantRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetCompetitionParticipantRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetCompetitionParticipantRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetCompetitionParticipantRoleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldParticipant participant = 1;
   */ _define_property(this, "participant", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetCompetitionParticipantRoleResponse, "runtime", proto3);
_define_property(SetCompetitionParticipantRoleResponse, "typeName", "mono.datagateway.v1.SetCompetitionParticipantRoleResponse");
_define_property(SetCompetitionParticipantRoleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant",
            kind: "message",
            T: CompetitiveFieldParticipant
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DowngradeIncumbentParticipantRequest
 */ export class DowngradeIncumbentParticipantRequest extends Message {
    static fromBinary(bytes, options) {
        return new DowngradeIncumbentParticipantRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DowngradeIncumbentParticipantRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DowngradeIncumbentParticipantRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DowngradeIncumbentParticipantRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 3;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string actor = 4;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DowngradeIncumbentParticipantRequest, "runtime", proto3);
_define_property(DowngradeIncumbentParticipantRequest, "typeName", "mono.datagateway.v1.DowngradeIncumbentParticipantRequest");
_define_property(DowngradeIncumbentParticipantRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DowngradeIncumbentParticipantResponse
 */ export class DowngradeIncumbentParticipantResponse extends Message {
    static fromBinary(bytes, options) {
        return new DowngradeIncumbentParticipantResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DowngradeIncumbentParticipantResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DowngradeIncumbentParticipantResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DowngradeIncumbentParticipantResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldParticipant participant = 1;
   */ _define_property(this, "participant", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DowngradeIncumbentParticipantResponse, "runtime", proto3);
_define_property(DowngradeIncumbentParticipantResponse, "typeName", "mono.datagateway.v1.DowngradeIncumbentParticipantResponse");
_define_property(DowngradeIncumbentParticipantResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant",
            kind: "message",
            T: CompetitiveFieldParticipant
        }
    ]));
/**
 * RecordCompetitiveFieldAssessment creates the first assessment for a
 * participant, or revises the live one by new row when one already exists.
 * It never updates an assessment in place.
 *
 * @generated from message mono.datagateway.v1.RecordCompetitiveFieldAssessmentRequest
 */ export class RecordCompetitiveFieldAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCompetitiveFieldAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCompetitiveFieldAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCompetitiveFieldAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCompetitiveFieldAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0), /**
   * The capture project the caller was authorized against upstream (in
   * zou). Verified against the participant's owning capture project before
   * any write — never derived from the participant as a fallback.
   *
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCompetitiveFieldAssessmentRequest, "runtime", proto3);
_define_property(RecordCompetitiveFieldAssessmentRequest, "typeName", "mono.datagateway.v1.RecordCompetitiveFieldAssessmentRequest");
_define_property(RecordCompetitiveFieldAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: CompetitiveFieldAssessment
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordCompetitiveFieldAssessmentResponse
 */ export class RecordCompetitiveFieldAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCompetitiveFieldAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCompetitiveFieldAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCompetitiveFieldAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCompetitiveFieldAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCompetitiveFieldAssessmentResponse, "runtime", proto3);
_define_property(RecordCompetitiveFieldAssessmentResponse, "typeName", "mono.datagateway.v1.RecordCompetitiveFieldAssessmentResponse");
_define_property(RecordCompetitiveFieldAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: CompetitiveFieldAssessment
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCompetitiveFieldStrategyRequest
 */ export class UpsertCompetitiveFieldStrategyRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompetitiveFieldStrategyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompetitiveFieldStrategyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompetitiveFieldStrategyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompetitiveFieldStrategyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldStrategy strategy = 1;
   */ _define_property(this, "strategy", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompetitiveFieldStrategyRequest, "runtime", proto3);
_define_property(UpsertCompetitiveFieldStrategyRequest, "typeName", "mono.datagateway.v1.UpsertCompetitiveFieldStrategyRequest");
_define_property(UpsertCompetitiveFieldStrategyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "strategy",
            kind: "message",
            T: CompetitiveFieldStrategy
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCompetitiveFieldStrategyResponse
 */ export class UpsertCompetitiveFieldStrategyResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompetitiveFieldStrategyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompetitiveFieldStrategyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompetitiveFieldStrategyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompetitiveFieldStrategyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitiveFieldStrategy strategy = 1;
   */ _define_property(this, "strategy", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompetitiveFieldStrategyResponse, "runtime", proto3);
_define_property(UpsertCompetitiveFieldStrategyResponse, "typeName", "mono.datagateway.v1.UpsertCompetitiveFieldStrategyResponse");
_define_property(UpsertCompetitiveFieldStrategyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "strategy",
            kind: "message",
            T: CompetitiveFieldStrategy
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * RecordCompetitorEvidence appends one evidence row. There is no update or
 * delete RPC — a correction or contradiction is always a new row.
 *
 * @generated from message mono.datagateway.v1.RecordCompetitorEvidenceRequest
 */ export class RecordCompetitorEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCompetitorEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCompetitorEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCompetitorEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCompetitorEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitorEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0), /**
   * The capture project the caller was authorized against upstream (in
   * zou). Verified against the participant's owning capture project before
   * any write — never derived from the participant as a fallback.
   *
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCompetitorEvidenceRequest, "runtime", proto3);
_define_property(RecordCompetitorEvidenceRequest, "typeName", "mono.datagateway.v1.RecordCompetitorEvidenceRequest");
_define_property(RecordCompetitorEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: CompetitorEvidence
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordCompetitorEvidenceResponse
 */ export class RecordCompetitorEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCompetitorEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCompetitorEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCompetitorEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCompetitorEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompetitorEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCompetitorEvidenceResponse, "runtime", proto3);
_define_property(RecordCompetitorEvidenceResponse, "typeName", "mono.datagateway.v1.RecordCompetitorEvidenceResponse");
_define_property(RecordCompetitorEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: CompetitorEvidence
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertBlackHatInputRequest
 */ export class UpsertBlackHatInputRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertBlackHatInputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertBlackHatInputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertBlackHatInputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertBlackHatInputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BlackHatInput input = 1;
   */ _define_property(this, "input", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertBlackHatInputRequest, "runtime", proto3);
_define_property(UpsertBlackHatInputRequest, "typeName", "mono.datagateway.v1.UpsertBlackHatInputRequest");
_define_property(UpsertBlackHatInputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "input",
            kind: "message",
            T: BlackHatInput
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertBlackHatInputResponse
 */ export class UpsertBlackHatInputResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertBlackHatInputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertBlackHatInputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertBlackHatInputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertBlackHatInputResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BlackHatInput input = 1;
   */ _define_property(this, "input", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertBlackHatInputResponse, "runtime", proto3);
_define_property(UpsertBlackHatInputResponse, "typeName", "mono.datagateway.v1.UpsertBlackHatInputResponse");
_define_property(UpsertBlackHatInputResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "input",
            kind: "message",
            T: BlackHatInput
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteBlackHatInputRequest
 */ export class DeleteBlackHatInputRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteBlackHatInputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteBlackHatInputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteBlackHatInputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteBlackHatInputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteBlackHatInputRequest, "runtime", proto3);
_define_property(DeleteBlackHatInputRequest, "typeName", "mono.datagateway.v1.DeleteBlackHatInputRequest");
_define_property(DeleteBlackHatInputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteBlackHatInputResponse
 */ export class DeleteBlackHatInputResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteBlackHatInputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteBlackHatInputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteBlackHatInputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteBlackHatInputResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteBlackHatInputResponse, "runtime", proto3);
_define_property(DeleteBlackHatInputResponse, "typeName", "mono.datagateway.v1.DeleteBlackHatInputResponse");
_define_property(DeleteBlackHatInputResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.ReviewBlackHatInputRequest
 */ export class ReviewBlackHatInputRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewBlackHatInputRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewBlackHatInputRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewBlackHatInputRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewBlackHatInputRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string reviewer_user_id = 4;
   */ _define_property(this, "reviewerUserId", ""), /**
   * @generated from field: string review_note = 5;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewBlackHatInputRequest, "runtime", proto3);
_define_property(ReviewBlackHatInputRequest, "typeName", "mono.datagateway.v1.ReviewBlackHatInputRequest");
_define_property(ReviewBlackHatInputRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reviewer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewBlackHatInputResponse
 */ export class ReviewBlackHatInputResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewBlackHatInputResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewBlackHatInputResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewBlackHatInputResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewBlackHatInputResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BlackHatInput input = 1;
   */ _define_property(this, "input", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewBlackHatInputResponse, "runtime", proto3);
_define_property(ReviewBlackHatInputResponse, "typeName", "mono.datagateway.v1.ReviewBlackHatInputResponse");
_define_property(ReviewBlackHatInputResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "input",
            kind: "message",
            T: BlackHatInput
        }
    ]));
/**
 * LibraryItemReference points at an existing artifact/document (or an
 * external citation) that a LibraryItem draws from — never a copy (C6-02).
 * Mirrors the D2 source-location vocabulary used by delivery.SourceReference
 * and GrowthValueProvenance (block_id/page/span/section/quote).
 *
 * @generated from message mono.datagateway.v1.LibraryItemReference
 */ export class LibraryItemReference extends Message {
    static fromBinary(bytes, options) {
        return new LibraryItemReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryItemReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryItemReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryItemReference, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string library_item_id = 3;
   */ _define_property(this, "libraryItemId", ""), /**
   * artifact|artifact_version|external
   *
   * @generated from field: string reference_kind = 4;
   */ _define_property(this, "referenceKind", ""), /**
   * @generated from field: string artifact_id = 5;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 6;
   */ _define_property(this, "artifactVersionId", ""), /**
   * @generated from field: string content_sha256 = 7;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string block_id = 8;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: int32 page = 9;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string span = 10;
   */ _define_property(this, "span", ""), /**
   * @generated from field: string section = 11;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string quote = 12;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string external_reference = 13;
   */ _define_property(this, "externalReference", ""), /**
   * @generated from field: string label = 14;
   */ _define_property(this, "label", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryItemReference, "runtime", proto3);
_define_property(LibraryItemReference, "typeName", "mono.datagateway.v1.LibraryItemReference");
_define_property(LibraryItemReference, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reference_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "external_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * LibraryItem is one reusable-item record (C6-01, C6-10).
 * provider_company_profile_id is the entity the content is about (our own
 * company or an external provider, C6-03) — distinct from owner_user_id, the
 * user who owns/maintains this record. owning_scope_object_type/id is an
 * optional, unenforced (type, id) pair pointing at an owning Program/Pursuit
 * in zou — never a cross-database FK, the same pattern CaptureProject's
 * zou_project_id already uses.
 *
 * @generated from message mono.datagateway.v1.LibraryItem
 */ export class LibraryItem extends Message {
    static fromBinary(bytes, options) {
        return new LibraryItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * evidence|template|proof_point|narrative|reference
   *
   * @generated from field: string item_type = 5;
   */ _define_property(this, "itemType", ""), /**
   * @generated from field: string customer_agency_name = 6;
   */ _define_property(this, "customerAgencyName", ""), /**
   * @generated from field: string provider_company_profile_id = 7;
   */ _define_property(this, "providerCompanyProfileId", ""), /**
   * @generated from field: string scope_context = 8;
   */ _define_property(this, "scopeContext", ""), /**
   * @generated from field: string capability_context = 9;
   */ _define_property(this, "capabilityContext", ""), /**
   * draft|released|withdrawn (C-LIFE-01-style). CreateLibraryItem only ever
   * accepts "draft" — see LibraryItemRepository.Create's doc comment.
   *
   * @generated from field: string status = 10;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string owner_user_id = 11;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string owning_scope_object_type = 12;
   */ _define_property(this, "owningScopeObjectType", ""), /**
   * @generated from field: string owning_scope_object_id = 13;
   */ _define_property(this, "owningScopeObjectId", ""), /**
   * @generated from field: string prepared_content = 14;
   */ _define_property(this, "preparedContent", ""), /**
   * plain_text|markdown|html
   *
   * @generated from field: string prepared_content_format = 15;
   */ _define_property(this, "preparedContentFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 16;
   */ _define_property(this, "effectiveDate", void 0), /**
   * Points at the shared Growth provenance envelope (GrowthValueProvenance,
   * SAD-425/GPF-01) instead of a second one — see LibraryItemRepository.Create.
   *
   * @generated from field: string provenance_record_id = 17;
   */ _define_property(this, "provenanceRecordId", ""), /**
   * Release authority — shell only in this stage; always empty until a
   * later stage's Release RPC sets it.
   *
   * @generated from field: string released_by = 18;
   */ _define_property(this, "releasedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp released_at = 19;
   */ _define_property(this, "releasedAt", void 0), /**
   * @generated from field: string release_audience = 20;
   */ _define_property(this, "releaseAudience", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 22;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 23;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string created_by = 24;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string updated_by = 25;
   */ _define_property(this, "updatedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryItem, "runtime", proto3);
_define_property(LibraryItem, "typeName", "mono.datagateway.v1.LibraryItem");
_define_property(LibraryItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "item_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "customer_agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "provider_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "scope_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "capability_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "owning_scope_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "owning_scope_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "prepared_content",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "prepared_content_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "released_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "released_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "release_audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 23,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 24,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * LibraryItemSourceLocation is the D2 source-location info CreateLibraryItem
 * forwards into a GrowthValueProvenance row when supplied. Leave every field
 * unset (or omit `source` entirely) to skip the provenance write — see
 * LibraryItemRepository.Create / LibraryItemSourceLocation.
 *
 * @generated from message mono.datagateway.v1.LibraryItemSourceLocation
 */ export class LibraryItemSourceLocation extends Message {
    static fromBinary(bytes, options) {
        return new LibraryItemSourceLocation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibraryItemSourceLocation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibraryItemSourceLocation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibraryItemSourceLocation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 2;
   */ _define_property(this, "artifactVersionId", ""), /**
   * @generated from field: string content_sha256 = 3;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string block_id = 4;
   */ _define_property(this, "blockId", ""), /**
   * @generated from field: int32 page = 5;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string section = 6;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string quote = 7;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string span = 8;
   */ _define_property(this, "span", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibraryItemSourceLocation, "runtime", proto3);
_define_property(LibraryItemSourceLocation, "typeName", "mono.datagateway.v1.LibraryItemSourceLocation");
_define_property(LibraryItemSourceLocation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "block_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "span",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * --- CreateLibraryItem ---
 *
 * @generated from message mono.datagateway.v1.CreateLibraryItemRequest
 */ export class CreateLibraryItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateLibraryItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLibraryItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLibraryItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLibraryItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LibraryItem item = 1;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.LibraryItemReference references = 2;
   */ _define_property(this, "references", []), /**
   * @generated from field: mono.datagateway.v1.LibraryItemSourceLocation source = 3;
   */ _define_property(this, "source", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLibraryItemRequest, "runtime", proto3);
_define_property(CreateLibraryItemRequest, "typeName", "mono.datagateway.v1.CreateLibraryItemRequest");
_define_property(CreateLibraryItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: LibraryItem
        },
        {
            no: 2,
            name: "references",
            kind: "message",
            T: LibraryItemReference,
            repeated: true
        },
        {
            no: 3,
            name: "source",
            kind: "message",
            T: LibraryItemSourceLocation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateLibraryItemResponse
 */ export class CreateLibraryItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateLibraryItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLibraryItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLibraryItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLibraryItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LibraryItem item = 1;
   */ _define_property(this, "item", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.LibraryItemReference references = 2;
   */ _define_property(this, "references", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLibraryItemResponse, "runtime", proto3);
_define_property(CreateLibraryItemResponse, "typeName", "mono.datagateway.v1.CreateLibraryItemResponse");
_define_property(CreateLibraryItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: LibraryItem
        },
        {
            no: 2,
            name: "references",
            kind: "message",
            T: LibraryItemReference,
            repeated: true
        }
    ]));
/**
 * --- GetLibraryItem ---
 *
 * @generated from message mono.datagateway.v1.GetLibraryItemRequest
 */ export class GetLibraryItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLibraryItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLibraryItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLibraryItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLibraryItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLibraryItemRequest, "runtime", proto3);
_define_property(GetLibraryItemRequest, "typeName", "mono.datagateway.v1.GetLibraryItemRequest");
_define_property(GetLibraryItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLibraryItemResponse
 */ export class GetLibraryItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLibraryItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLibraryItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLibraryItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLibraryItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LibraryItem item = 1;
   */ _define_property(this, "item", void 0), /**
   * The files and passages the item points at (a template's .docx, an
   * asset's image), in creation order.
   *
   * @generated from field: repeated mono.datagateway.v1.LibraryItemReference references = 2;
   */ _define_property(this, "references", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLibraryItemResponse, "runtime", proto3);
_define_property(GetLibraryItemResponse, "typeName", "mono.datagateway.v1.GetLibraryItemResponse");
_define_property(GetLibraryItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: LibraryItem
        },
        {
            no: 2,
            name: "references",
            kind: "message",
            T: LibraryItemReference,
            repeated: true
        }
    ]));
/**
 * --- SearchLibraryItems ---
 *
 * LibrarySearchFilter covers the C6-10 filter set: free text, item_type,
 * customer/agency, provider company, scope/capability context, recency and
 * status, plus the discovery-vs-owner scope split below. Mirrors
 * LibrarySearchFilter in library_repository.go field-for-field.
 *
 * @generated from message mono.datagateway.v1.LibrarySearchFilter
 */ export class LibrarySearchFilter extends Message {
    static fromBinary(bytes, options) {
        return new LibrarySearchFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LibrarySearchFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LibrarySearchFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LibrarySearchFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * discovery|owner. Empty defaults to "discovery" (C6-01's default view:
   * currently released items, any owner). "owner" is an authorized owner's
   * own drafts/history regardless of status — requires owner_user_id. The
   * two are never blended in one search.
   *
   * @generated from field: string scope = 2;
   */ _define_property(this, "scope", ""), /**
   * required when scope == "owner"
   *
   * @generated from field: string owner_user_id = 3;
   */ _define_property(this, "ownerUserId", ""), /**
   * free text over title/summary
   *
   * @generated from field: string query = 4;
   */ _define_property(this, "query", ""), /**
   * @generated from field: string item_type = 5;
   */ _define_property(this, "itemType", ""), /**
   * @generated from field: string customer_agency_name = 6;
   */ _define_property(this, "customerAgencyName", ""), /**
   * @generated from field: string provider_company_profile_id = 7;
   */ _define_property(this, "providerCompanyProfileId", ""), /**
   * @generated from field: string scope_context = 8;
   */ _define_property(this, "scopeContext", ""), /**
   * @generated from field: string capability_context = 9;
   */ _define_property(this, "capabilityContext", ""), /**
   * optional explicit filter, narrows scope's default
   *
   * @generated from field: string status = 10;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_since = 11;
   */ _define_property(this, "updatedSince", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LibrarySearchFilter, "runtime", proto3);
_define_property(LibrarySearchFilter, "typeName", "mono.datagateway.v1.LibrarySearchFilter");
_define_property(LibrarySearchFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "item_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "customer_agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "provider_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "scope_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "capability_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "updated_since",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SearchLibraryItemsRequest
 */ export class SearchLibraryItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchLibraryItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchLibraryItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchLibraryItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchLibraryItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LibrarySearchFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchLibraryItemsRequest, "runtime", proto3);
_define_property(SearchLibraryItemsRequest, "typeName", "mono.datagateway.v1.SearchLibraryItemsRequest");
_define_property(SearchLibraryItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: LibrarySearchFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SearchLibraryItemsResponse
 */ export class SearchLibraryItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchLibraryItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchLibraryItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchLibraryItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchLibraryItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LibraryItem items = 1;
   */ _define_property(this, "items", []), /**
   * total is the DB-predicate match count (pre-pagination) returned by
   * LibraryItemRepository.Search's COUNT(*) — it reflects only the SQL WHERE
   * clause and knows NOTHING about per-row authorization. It is NOT an
   * authorized count. The browser-edge caller (zou, a later stage) MUST
   * derive its own displayed count from the rows it is actually permitted to
   * return to the viewer: surfacing this value directly to a viewer who may
   * not see every matching row is an existence leak.
   *
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchLibraryItemsResponse, "runtime", proto3);
_define_property(SearchLibraryItemsResponse, "typeName", "mono.datagateway.v1.SearchLibraryItemsResponse");
_define_property(SearchLibraryItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: LibraryItem,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * CustomerTheme is the identity/lifecycle row — record_state, origin and
 * which version is current. Substance (title/narrative/etc.) lives in
 * CustomerThemeVersion, never here. Appears in RESPONSES only: no request
 * message carries a whole CustomerTheme, because current_version_id /
 * current_version_authorship are output-only, server-derived pointers — see
 * the KEY GUARD note above. A client that wants to change substance sends a
 * CustomerThemeVersionInput to one of the Create/Suggest/Accept/Revise RPCs
 * instead.
 *
 * @generated from message mono.datagateway.v1.CustomerTheme
 */ export class CustomerTheme extends Message {
    static fromBinary(bytes, options) {
        return new CustomerTheme().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerTheme().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerTheme().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerTheme, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * suggested|accepted
   *
   * @generated from field: string record_state = 4;
   */ _define_property(this, "recordState", ""), /**
   * manual|ai_draft|touchpoint|notice_rfi_rfp|internal_note|web_research
   *
   * @generated from field: string origin_source = 5;
   */ _define_property(this, "originSource", ""), /**
   * @generated from field: string origin_reference = 6;
   */ _define_property(this, "originReference", ""), /**
   * @generated from field: string proposed_revision_of_id = 7;
   */ _define_property(this, "proposedRevisionOfId", ""), /**
   * Output-only. Never client-settable — see the KEY GUARD note above.
   *
   * @generated from field: string current_version_id = 8;
   */ _define_property(this, "currentVersionId", ""), /**
   * Output-only. Never client-settable — the repository forces this to
   * "human" on every path that can mark a theme accepted.
   *
   * @generated from field: string current_version_authorship = 9;
   */ _define_property(this, "currentVersionAuthorship", ""), /**
   * @generated from field: string accepted_by = 10;
   */ _define_property(this, "acceptedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp accepted_at = 11;
   */ _define_property(this, "acceptedAt", void 0), /**
   * @generated from field: string dismissed_by = 12;
   */ _define_property(this, "dismissedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp dismissed_at = 13;
   */ _define_property(this, "dismissedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 15;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string updated_by = 17;
   */ _define_property(this, "updatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 18;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerTheme, "runtime", proto3);
_define_property(CustomerTheme, "typeName", "mono.datagateway.v1.CustomerTheme");
_define_property(CustomerTheme, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "record_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "origin_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "origin_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "proposed_revision_of_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "current_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "current_version_authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "accepted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "accepted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "dismissed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "dismissed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * CustomerThemeVersion is one append-only substance row in a theme's
 * history — never updated, a new row per edit (human or ai_suggested).
 * Appears in responses only; a client submitting an edit sends a
 * CustomerThemeVersionInput instead (see below).
 *
 * @generated from message mono.datagateway.v1.CustomerThemeVersion
 */ export class CustomerThemeVersion extends Message {
    static fromBinary(bytes, options) {
        return new CustomerThemeVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerThemeVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerThemeVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerThemeVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string theme_id = 3;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: int32 version = 4;
   */ _define_property(this, "version", 0), /**
   * human|ai_suggested
   *
   * @generated from field: string authorship = 5;
   */ _define_property(this, "authorship", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string narrative = 7;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string why_evidence_supports = 8;
   */ _define_property(this, "whyEvidenceSupports", ""), /**
   * @generated from field: string why_it_matters = 9;
   */ _define_property(this, "whyItMatters", ""), /**
   * @generated from field: string implications = 10;
   */ _define_property(this, "implications", ""), /**
   * pain_point|hot_button|desired_outcome|constraint|other
   *
   * @generated from field: string category = 11;
   */ _define_property(this, "category", ""), /**
   * draft|emerging|established
   *
   * @generated from field: string maturity = 12;
   */ _define_property(this, "maturity", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 13;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string change_note = 14;
   */ _define_property(this, "changeNote", ""), /**
   * @generated from field: string authored_by = 15;
   */ _define_property(this, "authoredBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * Empty means unprioritized; otherwise low, medium or high.
   *
   * @generated from field: string priority = 17;
   */ _define_property(this, "priority", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerThemeVersion, "runtime", proto3);
_define_property(CustomerThemeVersion, "typeName", "mono.datagateway.v1.CustomerThemeVersion");
_define_property(CustomerThemeVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "why_evidence_supports",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "why_it_matters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "implications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "maturity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "change_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "authored_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CustomerThemeVersionInput is the substance a caller submits on
 * create/suggest/accept/revise. Deliberately has NO authorship field: the
 * server derives it on every path (forced "human" for the manual/accept/
 * revise paths; taken from the enclosing request's own authorship field on
 * the suggest path) so a client can never set
 * customer_theme_versions.authorship directly.
 *
 * @generated from message mono.datagateway.v1.CustomerThemeVersionInput
 */ export class CustomerThemeVersionInput extends Message {
    static fromBinary(bytes, options) {
        return new CustomerThemeVersionInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerThemeVersionInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerThemeVersionInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerThemeVersionInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string narrative = 2;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string why_evidence_supports = 3;
   */ _define_property(this, "whyEvidenceSupports", ""), /**
   * @generated from field: string why_it_matters = 4;
   */ _define_property(this, "whyItMatters", ""), /**
   * @generated from field: string implications = 5;
   */ _define_property(this, "implications", ""), /**
   * pain_point|hot_button|desired_outcome|constraint|other
   *
   * @generated from field: string category = 6;
   */ _define_property(this, "category", ""), /**
   * draft|emerging|established
   *
   * @generated from field: string maturity = 7;
   */ _define_property(this, "maturity", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 8;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string change_note = 9;
   */ _define_property(this, "changeNote", ""), /**
   * @generated from field: string authored_by = 10;
   */ _define_property(this, "authoredBy", ""), /**
   * Empty means unprioritized; otherwise low, medium or high.
   *
   * @generated from field: string priority = 11;
   */ _define_property(this, "priority", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerThemeVersionInput, "runtime", proto3);
_define_property(CustomerThemeVersionInput, "typeName", "mono.datagateway.v1.CustomerThemeVersionInput");
_define_property(CustomerThemeVersionInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "why_evidence_supports",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "why_it_matters",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "implications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "maturity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "change_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "authored_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CustomerThemeEvidence is append-only, mirroring CompetitorEvidence: no
 * update or delete RPC, only AttachCustomerThemeEvidence.
 *
 * @generated from message mono.datagateway.v1.CustomerThemeEvidence
 */ export class CustomerThemeEvidence extends Message {
    static fromBinary(bytes, options) {
        return new CustomerThemeEvidence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerThemeEvidence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerThemeEvidence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerThemeEvidence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string theme_id = 3;
   */ _define_property(this, "themeId", ""), /**
   * supports|contradicts
   *
   * @generated from field: string stance = 4;
   */ _define_property(this, "stance", ""), /**
   * customer_statement|internal_assessment|inference|unverified_report
   *
   * @generated from field: string assertion_kind = 5;
   */ _define_property(this, "assertionKind", ""), /**
   * manual|ai_draft|touchpoint|notice_rfi_rfp|internal_note|web_research|document
   *
   * @generated from field: string source_kind = 6;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 7;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string source_excerpt = 8;
   */ _define_property(this, "sourceExcerpt", ""), /**
   * @generated from field: google.protobuf.Timestamp source_date = 9;
   */ _define_property(this, "sourceDate", void 0), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 10;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string rationale = 11;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string supersedes_evidence_id = 12;
   */ _define_property(this, "supersedesEvidenceId", ""), /**
   * @generated from field: string provenance_record_id = 13;
   */ _define_property(this, "provenanceRecordId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 15;
   */ _define_property(this, "createdBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerThemeEvidence, "runtime", proto3);
_define_property(CustomerThemeEvidence, "typeName", "mono.datagateway.v1.CustomerThemeEvidence");
_define_property(CustomerThemeEvidence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "stance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "assertion_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_excerpt",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "supersedes_evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * --- CreateManualCustomerTheme ---
 * Creates a human-authored, accepted theme in one shot. version has no
 * authorship field to set — the repository forces "human" and stamps
 * accepted_by/accepted_at.
 *
 * @generated from message mono.datagateway.v1.CreateManualCustomerThemeRequest
 */ export class CreateManualCustomerThemeRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateManualCustomerThemeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateManualCustomerThemeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateManualCustomerThemeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateManualCustomerThemeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * manual|ai_draft|touchpoint|notice_rfi_rfp|internal_note|web_research
   *
   * @generated from field: string origin_source = 3;
   */ _define_property(this, "originSource", ""), /**
   * @generated from field: string created_by = 4;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string accepted_by = 5;
   */ _define_property(this, "acceptedBy", ""), /**
   * @generated from field: mono.datagateway.v1.CustomerThemeVersionInput version = 6;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateManualCustomerThemeRequest, "runtime", proto3);
_define_property(CreateManualCustomerThemeRequest, "typeName", "mono.datagateway.v1.CreateManualCustomerThemeRequest");
_define_property(CreateManualCustomerThemeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "origin_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "accepted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "version",
            kind: "message",
            T: CustomerThemeVersionInput
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateManualCustomerThemeResponse
 */ export class CreateManualCustomerThemeResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateManualCustomerThemeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateManualCustomerThemeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateManualCustomerThemeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateManualCustomerThemeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTheme theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateManualCustomerThemeResponse, "runtime", proto3);
_define_property(CreateManualCustomerThemeResponse, "typeName", "mono.datagateway.v1.CreateManualCustomerThemeResponse");
_define_property(CreateManualCustomerThemeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerTheme
        }
    ]));
/**
 * --- SuggestCustomerTheme ---
 * Creates a theme in record_state "suggested". Unlike the manual-create
 * path, the caller declares authorship explicitly (human for a manual draft
 * not yet accepted, or ai_suggested) — this is the one path where
 * authorship is caller-supplied, and it can never produce an accepted
 * theme (see AcceptCustomerThemeSuggestion).
 *
 * @generated from message mono.datagateway.v1.SuggestCustomerThemeRequest
 */ export class SuggestCustomerThemeRequest extends Message {
    static fromBinary(bytes, options) {
        return new SuggestCustomerThemeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestCustomerThemeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestCustomerThemeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestCustomerThemeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * manual|ai_draft|touchpoint|notice_rfi_rfp|internal_note|web_research
   *
   * @generated from field: string origin_source = 3;
   */ _define_property(this, "originSource", ""), /**
   * @generated from field: string proposed_revision_of_id = 4;
   */ _define_property(this, "proposedRevisionOfId", ""), /**
   * @generated from field: string created_by = 5;
   */ _define_property(this, "createdBy", ""), /**
   * human|ai_suggested
   *
   * @generated from field: string authorship = 6;
   */ _define_property(this, "authorship", ""), /**
   * @generated from field: mono.datagateway.v1.CustomerThemeVersionInput version = 7;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestCustomerThemeRequest, "runtime", proto3);
_define_property(SuggestCustomerThemeRequest, "typeName", "mono.datagateway.v1.SuggestCustomerThemeRequest");
_define_property(SuggestCustomerThemeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "origin_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposed_revision_of_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "version",
            kind: "message",
            T: CustomerThemeVersionInput
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SuggestCustomerThemeResponse
 */ export class SuggestCustomerThemeResponse extends Message {
    static fromBinary(bytes, options) {
        return new SuggestCustomerThemeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestCustomerThemeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestCustomerThemeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestCustomerThemeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTheme theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestCustomerThemeResponse, "runtime", proto3);
_define_property(SuggestCustomerThemeResponse, "typeName", "mono.datagateway.v1.SuggestCustomerThemeResponse");
_define_property(SuggestCustomerThemeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerTheme
        }
    ]));
/**
 * --- AcceptCustomerThemeSuggestion ---
 * Appends a human-authored version at max(version)+1 and repoints the theme
 * at it, setting record_state=accepted. version has no authorship field —
 * the repository forces "human".
 *
 * @generated from message mono.datagateway.v1.AcceptCustomerThemeSuggestionRequest
 */ export class AcceptCustomerThemeSuggestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcceptCustomerThemeSuggestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptCustomerThemeSuggestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptCustomerThemeSuggestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptCustomerThemeSuggestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: string accepted_by = 3;
   */ _define_property(this, "acceptedBy", ""), /**
   * @generated from field: mono.datagateway.v1.CustomerThemeVersionInput version = 4;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptCustomerThemeSuggestionRequest, "runtime", proto3);
_define_property(AcceptCustomerThemeSuggestionRequest, "typeName", "mono.datagateway.v1.AcceptCustomerThemeSuggestionRequest");
_define_property(AcceptCustomerThemeSuggestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "accepted_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "message",
            T: CustomerThemeVersionInput
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AcceptCustomerThemeSuggestionResponse
 */ export class AcceptCustomerThemeSuggestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcceptCustomerThemeSuggestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptCustomerThemeSuggestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptCustomerThemeSuggestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptCustomerThemeSuggestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTheme theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptCustomerThemeSuggestionResponse, "runtime", proto3);
_define_property(AcceptCustomerThemeSuggestionResponse, "typeName", "mono.datagateway.v1.AcceptCustomerThemeSuggestionResponse");
_define_property(AcceptCustomerThemeSuggestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerTheme
        }
    ]));
/**
 * --- ReviseCustomerTheme ---
 * Appends a human-authored version at max(version)+1 for an already-accepted
 * theme and repoints it, leaving prior versions intact. version has no
 * authorship field — the repository forces "human".
 *
 * @generated from message mono.datagateway.v1.ReviseCustomerThemeRequest
 */ export class ReviseCustomerThemeRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviseCustomerThemeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviseCustomerThemeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviseCustomerThemeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviseCustomerThemeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", ""), /**
   * @generated from field: string revised_by = 3;
   */ _define_property(this, "revisedBy", ""), /**
   * @generated from field: mono.datagateway.v1.CustomerThemeVersionInput version = 4;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviseCustomerThemeRequest, "runtime", proto3);
_define_property(ReviseCustomerThemeRequest, "typeName", "mono.datagateway.v1.ReviseCustomerThemeRequest");
_define_property(ReviseCustomerThemeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "revised_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "message",
            T: CustomerThemeVersionInput
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviseCustomerThemeResponse
 */ export class ReviseCustomerThemeResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviseCustomerThemeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviseCustomerThemeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviseCustomerThemeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviseCustomerThemeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTheme theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviseCustomerThemeResponse, "runtime", proto3);
_define_property(ReviseCustomerThemeResponse, "typeName", "mono.datagateway.v1.ReviseCustomerThemeResponse");
_define_property(ReviseCustomerThemeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerTheme
        }
    ]));
/**
 * --- GetCustomerTheme ---
 *
 * @generated from message mono.datagateway.v1.GetCustomerThemeRequest
 */ export class GetCustomerThemeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerThemeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerThemeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerThemeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerThemeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerThemeRequest, "runtime", proto3);
_define_property(GetCustomerThemeRequest, "typeName", "mono.datagateway.v1.GetCustomerThemeRequest");
_define_property(GetCustomerThemeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCustomerThemeResponse
 */ export class GetCustomerThemeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerThemeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerThemeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerThemeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerThemeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTheme theme = 1;
   */ _define_property(this, "theme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerThemeResponse, "runtime", proto3);
_define_property(GetCustomerThemeResponse, "typeName", "mono.datagateway.v1.GetCustomerThemeResponse");
_define_property(GetCustomerThemeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "theme",
            kind: "message",
            T: CustomerTheme
        }
    ]));
/**
 * --- ListCustomerThemeVersions ---
 *
 * @generated from message mono.datagateway.v1.ListCustomerThemeVersionsRequest
 */ export class ListCustomerThemeVersionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerThemeVersionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerThemeVersionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerThemeVersionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerThemeVersionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerThemeVersionsRequest, "runtime", proto3);
_define_property(ListCustomerThemeVersionsRequest, "typeName", "mono.datagateway.v1.ListCustomerThemeVersionsRequest");
_define_property(ListCustomerThemeVersionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCustomerThemeVersionsResponse
 */ export class ListCustomerThemeVersionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerThemeVersionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerThemeVersionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerThemeVersionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerThemeVersionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CustomerThemeVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerThemeVersionsResponse, "runtime", proto3);
_define_property(ListCustomerThemeVersionsResponse, "typeName", "mono.datagateway.v1.ListCustomerThemeVersionsResponse");
_define_property(ListCustomerThemeVersionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: CustomerThemeVersion,
            repeated: true
        }
    ]));
/**
 * --- ListCustomerThemesByPursuit ---
 *
 * @generated from message mono.datagateway.v1.ListCustomerThemesByPursuitRequest
 */ export class ListCustomerThemesByPursuitRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerThemesByPursuitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerThemesByPursuitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerThemesByPursuitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerThemesByPursuitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerThemesByPursuitRequest, "runtime", proto3);
_define_property(ListCustomerThemesByPursuitRequest, "typeName", "mono.datagateway.v1.ListCustomerThemesByPursuitRequest");
_define_property(ListCustomerThemesByPursuitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCustomerThemesByPursuitResponse
 */ export class ListCustomerThemesByPursuitResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerThemesByPursuitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerThemesByPursuitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerThemesByPursuitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerThemesByPursuitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CustomerTheme themes = 1;
   */ _define_property(this, "themes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerThemesByPursuitResponse, "runtime", proto3);
_define_property(ListCustomerThemesByPursuitResponse, "typeName", "mono.datagateway.v1.ListCustomerThemesByPursuitResponse");
_define_property(ListCustomerThemesByPursuitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "themes",
            kind: "message",
            T: CustomerTheme,
            repeated: true
        }
    ]));
/**
 * --- AttachCustomerThemeEvidence ---
 * Appends one evidence row for an EXISTING theme in the same tenant. Never
 * mutates the theme.
 *
 * @generated from message mono.datagateway.v1.AttachCustomerThemeEvidenceRequest
 */ export class AttachCustomerThemeEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new AttachCustomerThemeEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachCustomerThemeEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachCustomerThemeEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachCustomerThemeEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerThemeEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachCustomerThemeEvidenceRequest, "runtime", proto3);
_define_property(AttachCustomerThemeEvidenceRequest, "typeName", "mono.datagateway.v1.AttachCustomerThemeEvidenceRequest");
_define_property(AttachCustomerThemeEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: CustomerThemeEvidence
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AttachCustomerThemeEvidenceResponse
 */ export class AttachCustomerThemeEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new AttachCustomerThemeEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AttachCustomerThemeEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AttachCustomerThemeEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AttachCustomerThemeEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerThemeEvidence evidence = 1;
   */ _define_property(this, "evidence", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AttachCustomerThemeEvidenceResponse, "runtime", proto3);
_define_property(AttachCustomerThemeEvidenceResponse, "typeName", "mono.datagateway.v1.AttachCustomerThemeEvidenceResponse");
_define_property(AttachCustomerThemeEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: CustomerThemeEvidence
        }
    ]));
/**
 * --- ListCustomerThemeEvidence ---
 *
 * @generated from message mono.datagateway.v1.ListCustomerThemeEvidenceRequest
 */ export class ListCustomerThemeEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerThemeEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerThemeEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerThemeEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerThemeEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string theme_id = 2;
   */ _define_property(this, "themeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerThemeEvidenceRequest, "runtime", proto3);
_define_property(ListCustomerThemeEvidenceRequest, "typeName", "mono.datagateway.v1.ListCustomerThemeEvidenceRequest");
_define_property(ListCustomerThemeEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCustomerThemeEvidenceResponse
 */ export class ListCustomerThemeEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerThemeEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerThemeEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerThemeEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerThemeEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CustomerThemeEvidence evidence = 1;
   */ _define_property(this, "evidence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerThemeEvidenceResponse, "runtime", proto3);
_define_property(ListCustomerThemeEvidenceResponse, "typeName", "mono.datagateway.v1.ListCustomerThemeEvidenceResponse");
_define_property(ListCustomerThemeEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: CustomerThemeEvidence,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PursuitStakeholder
 */ export class PursuitStakeholder extends Message {
    static fromBinary(bytes, options) {
        return new PursuitStakeholder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitStakeholder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitStakeholder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitStakeholder, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string contact_id = 4;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string unresolved_name = 5;
   */ _define_property(this, "unresolvedName", ""), /**
   * @generated from field: string unresolved_organization = 6;
   */ _define_property(this, "unresolvedOrganization", ""), /**
   * customer|internal|partner|unknown
   *
   * @generated from field: string affiliation = 7;
   */ _define_property(this, "affiliation", ""), /**
   * @generated from field: string pursuit_role = 8;
   */ _define_property(this, "pursuitRole", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.StakeholderRoleChange role_history = 12;
   */ _define_property(this, "roleHistory", []), /**
   * GRW-37 (D-SOR): the open REG-54 match candidate (delivery.registry_match_candidates.id)
   * a typed name waits on. A row has contact_id and no text, or a candidate
   * (chk_pursuit_stakeholders_link_only). Kept as provenance after resolution.
   *
   * @generated from field: string registry_candidate_id = 13;
   */ _define_property(this, "registryCandidateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitStakeholder, "runtime", proto3);
_define_property(PursuitStakeholder, "typeName", "mono.datagateway.v1.PursuitStakeholder");
_define_property(PursuitStakeholder, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "unresolved_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "unresolved_organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "affiliation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "pursuit_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "role_history",
            kind: "message",
            T: StakeholderRoleChange,
            repeated: true
        },
        {
            no: 13,
            name: "registry_candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * StakeholderAssessment is the sensitive pursuit-specific layer, revised by
 * new row: supersedes_id + superseded_at chain a revision to its
 * predecessor, never an UPDATE of the predecessor's substance. At most one
 * live (superseded_at unset) accepted row per stakeholder.
 *
 * @generated from message mono.datagateway.v1.StakeholderAssessment
 */ export class StakeholderAssessment extends Message {
    static fromBinary(bytes, options) {
        return new StakeholderAssessment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StakeholderAssessment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StakeholderAssessment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StakeholderAssessment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string stakeholder_id = 3;
   */ _define_property(this, "stakeholderId", ""), /**
   * low|medium|high|unknown
   *
   * @generated from field: string influence_band = 4;
   */ _define_property(this, "influenceBand", ""), /**
   * advocate|neutral|skeptic|blocker|unknown
   *
   * @generated from field: string relationship_posture = 5;
   */ _define_property(this, "relationshipPosture", ""), /**
   * @generated from field: string priorities = 6;
   */ _define_property(this, "priorities", ""), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: string uncertainty_note = 8;
   */ _define_property(this, "uncertaintyNote", ""), /**
   * low|medium|high
   *
   * @generated from field: string confidence = 9;
   */ _define_property(this, "confidence", ""), /**
   * @generated from field: string source_kind = 10;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_ref = 11;
   */ _define_property(this, "sourceRef", ""), /**
   * human|ai_suggested
   *
   * @generated from field: string authorship = 12;
   */ _define_property(this, "authorship", ""), /**
   * suggested|accepted
   *
   * @generated from field: string assessment_state = 13;
   */ _define_property(this, "assessmentState", ""), /**
   * @generated from field: string supersedes_id = 14;
   */ _define_property(this, "supersedesId", ""), /**
   * @generated from field: google.protobuf.Timestamp superseded_at = 15;
   */ _define_property(this, "supersededAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp as_of_date = 16;
   */ _define_property(this, "asOfDate", void 0), /**
   * @generated from field: string provenance_record_id = 17;
   */ _define_property(this, "provenanceRecordId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string created_by = 19;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 20;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: repeated string theme_ids = 21;
   */ _define_property(this, "themeIds", []), /**
   * @generated from field: string pursuit_role = 22;
   */ _define_property(this, "pursuitRole", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StakeholderAssessment, "runtime", proto3);
_define_property(StakeholderAssessment, "typeName", "mono.datagateway.v1.StakeholderAssessment");
_define_property(StakeholderAssessment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "stakeholder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "influence_band",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "relationship_posture",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "priorities",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "uncertainty_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "confidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "authorship",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "assessment_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "supersedes_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "superseded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "as_of_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "provenance_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "theme_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 22,
            name: "pursuit_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * --- UpsertPursuitStakeholder ---
 *
 * @generated from message mono.datagateway.v1.UpsertPursuitStakeholderRequest
 */ export class UpsertPursuitStakeholderRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPursuitStakeholderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPursuitStakeholderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPursuitStakeholderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPursuitStakeholderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitStakeholder stakeholder = 1;
   */ _define_property(this, "stakeholder", void 0), /**
   * GRW-37: create the row with stakeholder.id (a caller-minted UUID). zou
   * mints the id first so the REG-54 candidate's binder can name the row.
   *
   * @generated from field: bool create_with_id = 2;
   */ _define_property(this, "createWithId", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPursuitStakeholderRequest, "runtime", proto3);
_define_property(UpsertPursuitStakeholderRequest, "typeName", "mono.datagateway.v1.UpsertPursuitStakeholderRequest");
_define_property(UpsertPursuitStakeholderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "stakeholder",
            kind: "message",
            T: PursuitStakeholder
        },
        {
            no: 2,
            name: "create_with_id",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertPursuitStakeholderResponse
 */ export class UpsertPursuitStakeholderResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertPursuitStakeholderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertPursuitStakeholderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertPursuitStakeholderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertPursuitStakeholderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitStakeholder stakeholder = 1;
   */ _define_property(this, "stakeholder", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertPursuitStakeholderResponse, "runtime", proto3);
_define_property(UpsertPursuitStakeholderResponse, "typeName", "mono.datagateway.v1.UpsertPursuitStakeholderResponse");
_define_property(UpsertPursuitStakeholderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "stakeholder",
            kind: "message",
            T: PursuitStakeholder
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * --- RecordStakeholderAssessment ---
 * Inserts a new assessment row. If assessment.assessment_state is
 * "accepted", the prior live accepted row for the same stakeholder (if any)
 * is superseded inside the same transaction — never an UPDATE in place.
 *
 * @generated from message mono.datagateway.v1.RecordStakeholderAssessmentRequest
 */ export class RecordStakeholderAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordStakeholderAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordStakeholderAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordStakeholderAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordStakeholderAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.StakeholderAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordStakeholderAssessmentRequest, "runtime", proto3);
_define_property(RecordStakeholderAssessmentRequest, "typeName", "mono.datagateway.v1.RecordStakeholderAssessmentRequest");
_define_property(RecordStakeholderAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: StakeholderAssessment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordStakeholderAssessmentResponse
 */ export class RecordStakeholderAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordStakeholderAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordStakeholderAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordStakeholderAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordStakeholderAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.StakeholderAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordStakeholderAssessmentResponse, "runtime", proto3);
_define_property(RecordStakeholderAssessmentResponse, "typeName", "mono.datagateway.v1.RecordStakeholderAssessmentResponse");
_define_property(RecordStakeholderAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: StakeholderAssessment
        }
    ]));
/**
 * --- ListStakeholderAssessments ---
 * Returns a stakeholder's assessment history newest first; history is
 * retained, never pruned.
 *
 * @generated from message mono.datagateway.v1.ListStakeholderAssessmentsRequest
 */ export class ListStakeholderAssessmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListStakeholderAssessmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListStakeholderAssessmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListStakeholderAssessmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListStakeholderAssessmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string stakeholder_id = 2;
   */ _define_property(this, "stakeholderId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListStakeholderAssessmentsRequest, "runtime", proto3);
_define_property(ListStakeholderAssessmentsRequest, "typeName", "mono.datagateway.v1.ListStakeholderAssessmentsRequest");
_define_property(ListStakeholderAssessmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "stakeholder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListStakeholderAssessmentsResponse
 */ export class ListStakeholderAssessmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListStakeholderAssessmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListStakeholderAssessmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListStakeholderAssessmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListStakeholderAssessmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.StakeholderAssessment assessments = 1;
   */ _define_property(this, "assessments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListStakeholderAssessmentsResponse, "runtime", proto3);
_define_property(ListStakeholderAssessmentsResponse, "typeName", "mono.datagateway.v1.ListStakeholderAssessmentsResponse");
_define_property(ListStakeholderAssessmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessments",
            kind: "message",
            T: StakeholderAssessment,
            repeated: true
        }
    ]));
/**
 * --- GetPursuitStakeholder ---
 *
 * @generated from message mono.datagateway.v1.GetPursuitStakeholderRequest
 */ export class GetPursuitStakeholderRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitStakeholderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitStakeholderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitStakeholderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitStakeholderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string stakeholder_id = 2;
   */ _define_property(this, "stakeholderId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitStakeholderRequest, "runtime", proto3);
_define_property(GetPursuitStakeholderRequest, "typeName", "mono.datagateway.v1.GetPursuitStakeholderRequest");
_define_property(GetPursuitStakeholderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "stakeholder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPursuitStakeholderResponse
 */ export class GetPursuitStakeholderResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitStakeholderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitStakeholderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitStakeholderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitStakeholderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PursuitStakeholder stakeholder = 1;
   */ _define_property(this, "stakeholder", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitStakeholderResponse, "runtime", proto3);
_define_property(GetPursuitStakeholderResponse, "typeName", "mono.datagateway.v1.GetPursuitStakeholderResponse");
_define_property(GetPursuitStakeholderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "stakeholder",
            kind: "message",
            T: PursuitStakeholder
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Opportunity
 */ export class Opportunity extends Message {
    static fromBinary(bytes, options) {
        return new Opportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Opportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Opportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Opportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string created_by = 4;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Opportunity, "runtime", proto3);
_define_property(Opportunity, "typeName", "mono.datagateway.v1.Opportunity");
_define_property(Opportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OpportunityNoticeLink
 */ export class OpportunityNoticeLink extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityNoticeLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityNoticeLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityNoticeLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityNoticeLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 4;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string created_by = 5;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityNoticeLink, "runtime", proto3);
_define_property(OpportunityNoticeLink, "typeName", "mono.datagateway.v1.OpportunityNoticeLink");
_define_property(OpportunityNoticeLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateOpportunityRequest
 */ export class CreateOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string created_by = 3;
   */ _define_property(this, "createdBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOpportunityRequest, "runtime", proto3);
_define_property(CreateOpportunityRequest, "typeName", "mono.datagateway.v1.CreateOpportunityRequest");
_define_property(CreateOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateOpportunityResponse
 */ export class CreateOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Opportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOpportunityResponse, "runtime", proto3);
_define_property(CreateOpportunityResponse, "typeName", "mono.datagateway.v1.CreateOpportunityResponse");
_define_property(CreateOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityRequest
 */ export class GetOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityRequest, "runtime", proto3);
_define_property(GetOpportunityRequest, "typeName", "mono.datagateway.v1.GetOpportunityRequest");
_define_property(GetOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityResponse
 */ export class GetOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Opportunity opportunity = 1;
   */ _define_property(this, "opportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityResponse, "runtime", proto3);
_define_property(GetOpportunityResponse, "typeName", "mono.datagateway.v1.GetOpportunityResponse");
_define_property(GetOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity",
            kind: "message",
            T: Opportunity
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOpportunitiesRequest
 */ export class ListOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunitiesRequest, "runtime", proto3);
_define_property(ListOpportunitiesRequest, "typeName", "mono.datagateway.v1.ListOpportunitiesRequest");
_define_property(ListOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOpportunitiesResponse
 */ export class ListOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Opportunity opportunities = 1;
   */ _define_property(this, "opportunities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunitiesResponse, "runtime", proto3);
_define_property(ListOpportunitiesResponse, "typeName", "mono.datagateway.v1.ListOpportunitiesResponse");
_define_property(ListOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunities",
            kind: "message",
            T: Opportunity,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkOpportunityNoticeRequest
 */ export class LinkOpportunityNoticeRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkOpportunityNoticeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkOpportunityNoticeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkOpportunityNoticeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkOpportunityNoticeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string created_by = 4;
   */ _define_property(this, "createdBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkOpportunityNoticeRequest, "runtime", proto3);
_define_property(LinkOpportunityNoticeRequest, "typeName", "mono.datagateway.v1.LinkOpportunityNoticeRequest");
_define_property(LinkOpportunityNoticeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkOpportunityNoticeResponse
 */ export class LinkOpportunityNoticeResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkOpportunityNoticeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkOpportunityNoticeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkOpportunityNoticeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkOpportunityNoticeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityNoticeLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkOpportunityNoticeResponse, "runtime", proto3);
_define_property(LinkOpportunityNoticeResponse, "typeName", "mono.datagateway.v1.LinkOpportunityNoticeResponse");
_define_property(LinkOpportunityNoticeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: OpportunityNoticeLink
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnlinkOpportunityNoticeRequest
 */ export class UnlinkOpportunityNoticeRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkOpportunityNoticeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkOpportunityNoticeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkOpportunityNoticeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkOpportunityNoticeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkOpportunityNoticeRequest, "runtime", proto3);
_define_property(UnlinkOpportunityNoticeRequest, "typeName", "mono.datagateway.v1.UnlinkOpportunityNoticeRequest");
_define_property(UnlinkOpportunityNoticeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnlinkOpportunityNoticeResponse
 */ export class UnlinkOpportunityNoticeResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkOpportunityNoticeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkOpportunityNoticeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkOpportunityNoticeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkOpportunityNoticeResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkOpportunityNoticeResponse, "runtime", proto3);
_define_property(UnlinkOpportunityNoticeResponse, "typeName", "mono.datagateway.v1.UnlinkOpportunityNoticeResponse");
_define_property(UnlinkOpportunityNoticeResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.ListOpportunityNoticeLinksRequest
 */ export class ListOpportunityNoticeLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityNoticeLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityNoticeLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityNoticeLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityNoticeLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityNoticeLinksRequest, "runtime", proto3);
_define_property(ListOpportunityNoticeLinksRequest, "typeName", "mono.datagateway.v1.ListOpportunityNoticeLinksRequest");
_define_property(ListOpportunityNoticeLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOpportunityNoticeLinksResponse
 */ export class ListOpportunityNoticeLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOpportunityNoticeLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOpportunityNoticeLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOpportunityNoticeLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOpportunityNoticeLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OpportunityNoticeLink links = 1;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOpportunityNoticeLinksResponse, "runtime", proto3);
_define_property(ListOpportunityNoticeLinksResponse, "typeName", "mono.datagateway.v1.ListOpportunityNoticeLinksResponse");
_define_property(ListOpportunityNoticeLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: OpportunityNoticeLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.NoticePublication
 */ export class NoticePublication extends Message {
    static fromBinary(bytes, options) {
        return new NoticePublication().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoticePublication().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoticePublication().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoticePublication, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string notice_id = 3;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string root_notice_id = 4;
   */ _define_property(this, "rootNoticeId", ""), /**
   * @generated from field: int32 version = 5;
   */ _define_property(this, "version", 0), /**
   * original | amendment
   *
   * @generated from field: string publication_type = 6;
   */ _define_property(this, "publicationType", ""), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_identifier = 8;
   */ _define_property(this, "sourceIdentifier", ""), /**
   * @generated from field: string title = 9;
   */ _define_property(this, "title", ""), /**
   * not_required | pending_review | reviewed
   *
   * @generated from field: string review_status = 10;
   */ _define_property(this, "reviewStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 11;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: string created_by = 12;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * sam_ingest | manual
   *
   * @generated from field: string origin = 14;
   */ _define_property(this, "origin", ""), /**
   * who/where manual intel was received
   *
   * @generated from field: string provenance = 15;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: string reviewed_by = 16;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 17;
   */ _define_property(this, "reviewedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NoticePublication, "runtime", proto3);
_define_property(NoticePublication, "typeName", "mono.datagateway.v1.NoticePublication");
_define_property(NoticePublication, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "root_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "publication_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "review_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordNoticePublicationRequest
 */ export class RecordNoticePublicationRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordNoticePublicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordNoticePublicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordNoticePublicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordNoticePublicationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string parent_notice_id = 3;
   */ _define_property(this, "parentNoticeId", ""), /**
   * @generated from field: string source = 4;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_identifier = 5;
   */ _define_property(this, "sourceIdentifier", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string created_by = 7;
   */ _define_property(this, "createdBy", ""), /**
   * sam_ingest (default) | manual
   *
   * @generated from field: string origin = 8;
   */ _define_property(this, "origin", ""), /**
   * @generated from field: string provenance = 9;
   */ _define_property(this, "provenance", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordNoticePublicationRequest, "runtime", proto3);
_define_property(RecordNoticePublicationRequest, "typeName", "mono.datagateway.v1.RecordNoticePublicationRequest");
_define_property(RecordNoticePublicationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordNoticePublicationResponse
 */ export class RecordNoticePublicationResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordNoticePublicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordNoticePublicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordNoticePublicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordNoticePublicationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.NoticePublication publication = 1;
   */ _define_property(this, "publication", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordNoticePublicationResponse, "runtime", proto3);
_define_property(RecordNoticePublicationResponse, "typeName", "mono.datagateway.v1.RecordNoticePublicationResponse");
_define_property(RecordNoticePublicationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: NoticePublication
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListNoticePublicationsRequest
 */ export class ListNoticePublicationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticePublicationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticePublicationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticePublicationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticePublicationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string notice_id = 2;
   */ _define_property(this, "noticeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticePublicationsRequest, "runtime", proto3);
_define_property(ListNoticePublicationsRequest, "typeName", "mono.datagateway.v1.ListNoticePublicationsRequest");
_define_property(ListNoticePublicationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListNoticePublicationsResponse
 */ export class ListNoticePublicationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticePublicationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticePublicationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticePublicationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticePublicationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NoticePublication publications = 1;
   */ _define_property(this, "publications", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticePublicationsResponse, "runtime", proto3);
_define_property(ListNoticePublicationsResponse, "typeName", "mono.datagateway.v1.ListNoticePublicationsResponse");
_define_property(ListNoticePublicationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publications",
            kind: "message",
            T: NoticePublication,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewNoticePublicationRequest
 */ export class ReviewNoticePublicationRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewNoticePublicationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewNoticePublicationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewNoticePublicationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewNoticePublicationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string publication_id = 2;
   */ _define_property(this, "publicationId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewNoticePublicationRequest, "runtime", proto3);
_define_property(ReviewNoticePublicationRequest, "typeName", "mono.datagateway.v1.ReviewNoticePublicationRequest");
_define_property(ReviewNoticePublicationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "publication_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewNoticePublicationResponse
 */ export class ReviewNoticePublicationResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewNoticePublicationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewNoticePublicationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewNoticePublicationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewNoticePublicationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.NoticePublication publication = 1;
   */ _define_property(this, "publication", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewNoticePublicationResponse, "runtime", proto3);
_define_property(ReviewNoticePublicationResponse, "typeName", "mono.datagateway.v1.ReviewNoticePublicationResponse");
_define_property(ReviewNoticePublicationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "publication",
            kind: "message",
            T: NoticePublication
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.NoticeSourceCoverage
 */ export class NoticeSourceCoverage extends Message {
    static fromBinary(bytes, options) {
        return new NoticeSourceCoverage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoticeSourceCoverage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoticeSourceCoverage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoticeSourceCoverage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * e.g. sam_gov | manual
   *
   * @generated from field: string source = 4;
   */ _define_property(this, "source", ""), /**
   * unknown | unavailable | failed | stale | no_results | partial | current
   *
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string source_identifier = 6;
   */ _define_property(this, "sourceIdentifier", ""), /**
   * unset when never retrieved
   *
   * @generated from field: google.protobuf.Timestamp retrieved_at = 7;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: repeated string materials_obtained = 8;
   */ _define_property(this, "materialsObtained", []), /**
   * @generated from field: string detail = 9;
   */ _define_property(this, "detail", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NoticeSourceCoverage, "runtime", proto3);
_define_property(NoticeSourceCoverage, "typeName", "mono.datagateway.v1.NoticeSourceCoverage");
_define_property(NoticeSourceCoverage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "materials_obtained",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertNoticeSourceCoverageRequest
 */ export class UpsertNoticeSourceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertNoticeSourceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertNoticeSourceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertNoticeSourceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertNoticeSourceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string source = 3;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string source_identifier = 5;
   */ _define_property(this, "sourceIdentifier", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 6;
   */ _define_property(this, "retrievedAt", void 0), /**
   * @generated from field: repeated string materials_obtained = 7;
   */ _define_property(this, "materialsObtained", []), /**
   * @generated from field: string detail = 8;
   */ _define_property(this, "detail", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertNoticeSourceCoverageRequest, "runtime", proto3);
_define_property(UpsertNoticeSourceCoverageRequest, "typeName", "mono.datagateway.v1.UpsertNoticeSourceCoverageRequest");
_define_property(UpsertNoticeSourceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_identifier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "materials_obtained",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertNoticeSourceCoverageResponse
 */ export class UpsertNoticeSourceCoverageResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertNoticeSourceCoverageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertNoticeSourceCoverageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertNoticeSourceCoverageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertNoticeSourceCoverageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.NoticeSourceCoverage coverage = 1;
   */ _define_property(this, "coverage", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertNoticeSourceCoverageResponse, "runtime", proto3);
_define_property(UpsertNoticeSourceCoverageResponse, "typeName", "mono.datagateway.v1.UpsertNoticeSourceCoverageResponse");
_define_property(UpsertNoticeSourceCoverageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "coverage",
            kind: "message",
            T: NoticeSourceCoverage
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListNoticeSourceCoverageRequest
 */ export class ListNoticeSourceCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticeSourceCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticeSourceCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticeSourceCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticeSourceCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticeSourceCoverageRequest, "runtime", proto3);
_define_property(ListNoticeSourceCoverageRequest, "typeName", "mono.datagateway.v1.ListNoticeSourceCoverageRequest");
_define_property(ListNoticeSourceCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListNoticeSourceCoverageResponse
 */ export class ListNoticeSourceCoverageResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNoticeSourceCoverageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNoticeSourceCoverageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNoticeSourceCoverageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNoticeSourceCoverageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NoticeSourceCoverage coverage = 1;
   */ _define_property(this, "coverage", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNoticeSourceCoverageResponse, "runtime", proto3);
_define_property(ListNoticeSourceCoverageResponse, "typeName", "mono.datagateway.v1.ListNoticeSourceCoverageResponse");
_define_property(ListNoticeSourceCoverageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "coverage",
            kind: "message",
            T: NoticeSourceCoverage,
            repeated: true
        }
    ]));
/**
 * SAD-1005: a pending go/no-go decision on a pursuit the viewer captures.
 *
 * @generated from message mono.datagateway.v1.MyCaptureDecision
 */ export class MyCaptureDecision extends Message {
    static fromBinary(bytes, options) {
        return new MyCaptureDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MyCaptureDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MyCaptureDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MyCaptureDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * zou_project_id is the pursuit's scope object (capture_project access).
   *
   * @generated from field: string zou_project_id = 3;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string pursuit_name = 4;
   */ _define_property(this, "pursuitName", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 5;
   */ _define_property(this, "dueAt", void 0), /**
   * why: capture_manager | team_owner.
   *
   * @generated from field: string why = 6;
   */ _define_property(this, "why", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MyCaptureDecision, "runtime", proto3);
_define_property(MyCaptureDecision, "typeName", "mono.datagateway.v1.MyCaptureDecision");
_define_property(MyCaptureDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pursuit_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "why",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * SAD-1005: an open (open or in_progress) capture task the viewer owns.
 *
 * @generated from message mono.datagateway.v1.MyCaptureTask
 */ export class MyCaptureTask extends Message {
    static fromBinary(bytes, options) {
        return new MyCaptureTask().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MyCaptureTask().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MyCaptureTask().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MyCaptureTask, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string zou_project_id = 3;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string pursuit_name = 4;
   */ _define_property(this, "pursuitName", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 7;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MyCaptureTask, "runtime", proto3);
_define_property(MyCaptureTask, "typeName", "mono.datagateway.v1.MyCaptureTask");
_define_property(MyCaptureTask, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "pursuit_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListMyCaptureWorkRequest
 */ export class ListMyCaptureWorkRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListMyCaptureWorkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyCaptureWorkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyCaptureWorkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyCaptureWorkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * user_id is the viewer's platform user id.
   *
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyCaptureWorkRequest, "runtime", proto3);
_define_property(ListMyCaptureWorkRequest, "typeName", "mono.datagateway.v1.ListMyCaptureWorkRequest");
_define_property(ListMyCaptureWorkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListMyCaptureWorkResponse
 */ export class ListMyCaptureWorkResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListMyCaptureWorkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyCaptureWorkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyCaptureWorkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyCaptureWorkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.MyCaptureDecision decisions = 1;
   */ _define_property(this, "decisions", []), /**
   * @generated from field: repeated mono.datagateway.v1.MyCaptureTask tasks = 2;
   */ _define_property(this, "tasks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyCaptureWorkResponse, "runtime", proto3);
_define_property(ListMyCaptureWorkResponse, "typeName", "mono.datagateway.v1.ListMyCaptureWorkResponse");
_define_property(ListMyCaptureWorkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decisions",
            kind: "message",
            T: MyCaptureDecision,
            repeated: true
        },
        {
            no: 2,
            name: "tasks",
            kind: "message",
            T: MyCaptureTask,
            repeated: true
        }
    ]));
/**
 * Canonical identity is optional independently for each role. Source names and
 * manual context survive resolution. Selected source references must target this
 * Opportunity and this role's field path; raw quotes stay in source_references.
 *
 * @generated from message mono.datagateway.v1.OpportunityOrganizationContext
 */ export class OpportunityOrganizationContext extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityOrganizationContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityOrganizationContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityOrganizationContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityOrganizationContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string organization_id = 1;
   */ _define_property(this, "organizationId", ""), /**
   * @generated from field: string source_name = 2;
   */ _define_property(this, "sourceName", ""), /**
   * @generated from field: string manual_context = 3;
   */ _define_property(this, "manualContext", ""), /**
   * @generated from field: repeated string source_reference_ids = 4;
   */ _define_property(this, "sourceReferenceIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityOrganizationContext, "runtime", proto3);
_define_property(OpportunityOrganizationContext, "typeName", "mono.datagateway.v1.OpportunityOrganizationContext");
_define_property(OpportunityOrganizationContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "manual_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OpportunityContext
 */ export class OpportunityContext extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: mono.datagateway.v1.OpportunityOrganizationContext customer = 2;
   */ _define_property(this, "customer", void 0), /**
   * @generated from field: mono.datagateway.v1.OpportunityOrganizationContext contracting = 3;
   */ _define_property(this, "contracting", void 0), /**
   * @generated from field: string customer_confirmed_by = 4;
   */ _define_property(this, "customerConfirmedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp customer_confirmed_at = 5;
   */ _define_property(this, "customerConfirmedAt", void 0), /**
   * @generated from field: int32 version = 6;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityContext, "runtime", proto3);
_define_property(OpportunityContext, "typeName", "mono.datagateway.v1.OpportunityContext");
_define_property(OpportunityContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "customer",
            kind: "message",
            T: OpportunityOrganizationContext
        },
        {
            no: 3,
            name: "contracting",
            kind: "message",
            T: OpportunityOrganizationContext
        },
        {
            no: 4,
            name: "customer_confirmed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer_confirmed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityContextRequest
 */ export class GetOpportunityContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityContextRequest, "runtime", proto3);
_define_property(GetOpportunityContextRequest, "typeName", "mono.datagateway.v1.GetOpportunityContextRequest");
_define_property(GetOpportunityContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityContextResponse
 */ export class GetOpportunityContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityContext context = 1;
   */ _define_property(this, "context", void 0), /**
   * GRW-06: the opportunity's RFP-expected value (version 0 = never set).
   *
   * @generated from field: mono.datagateway.v1.OpportunityRfpExpected rfp_expected = 8;
   */ _define_property(this, "rfpExpected", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityContextResponse, "runtime", proto3);
_define_property(GetOpportunityContextResponse, "typeName", "mono.datagateway.v1.GetOpportunityContextResponse");
_define_property(GetOpportunityContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "context",
            kind: "message",
            T: OpportunityContext
        },
        {
            no: 8,
            name: "rfp_expected",
            kind: "message",
            T: OpportunityRfpExpected
        }
    ]));
/**
 * GRW-06 (SAD-1124): "RFP expected" on the canonical opportunity.
 *
 * @generated from message mono.datagateway.v1.OpportunityRfpExpected
 */ export class OpportunityRfpExpected extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityRfpExpected().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityRfpExpected().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityRfpExpected().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityRfpExpected, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * YYYY-MM-DD or "" when unset
   *
   * @generated from field: string rfp_expected_on = 2;
   */ _define_property(this, "rfpExpectedOn", ""), /**
   * customer_said | agency_forecast | notice | our_estimate | ""
   *
   * @generated from field: string basis = 3;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string note = 4;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string set_by = 5;
   */ _define_property(this, "setBy", ""), /**
   * RFC3339 or ""
   *
   * @generated from field: string set_at = 6;
   */ _define_property(this, "setAt", ""), /**
   * @generated from field: int32 version = 7;
   */ _define_property(this, "version", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityRfpExpected, "runtime", proto3);
_define_property(OpportunityRfpExpected, "typeName", "mono.datagateway.v1.OpportunityRfpExpected");
_define_property(OpportunityRfpExpected, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfp_expected_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "set_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "set_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetOpportunityRfpExpectedRequest
 */ export class SetOpportunityRfpExpectedRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityRfpExpectedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityRfpExpectedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityRfpExpectedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityRfpExpectedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * YYYY-MM-DD, or "" to clear
   *
   * @generated from field: string rfp_expected_on = 3;
   */ _define_property(this, "rfpExpectedOn", ""), /**
   * @generated from field: string basis = 4;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string note = 5;
   */ _define_property(this, "note", ""), /**
   * @generated from field: int32 expected_version = 6;
   */ _define_property(this, "expectedVersion", 0), /**
   * @generated from field: string actor = 7;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityRfpExpectedRequest, "runtime", proto3);
_define_property(SetOpportunityRfpExpectedRequest, "typeName", "mono.datagateway.v1.SetOpportunityRfpExpectedRequest");
_define_property(SetOpportunityRfpExpectedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfp_expected_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "expected_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetOpportunityRfpExpectedResponse
 */ export class SetOpportunityRfpExpectedResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityRfpExpectedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityRfpExpectedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityRfpExpectedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityRfpExpectedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityRfpExpected value = 1;
   */ _define_property(this, "value", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityRfpExpectedResponse, "runtime", proto3);
_define_property(SetOpportunityRfpExpectedResponse, "typeName", "mono.datagateway.v1.SetOpportunityRfpExpectedResponse");
_define_property(SetOpportunityRfpExpectedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "value",
            kind: "message",
            T: OpportunityRfpExpected
        }
    ]));
/**
 * Full replacement, optimistic version check (zero for first write). Setting or
 * changing a customer ID requires confirm_customer=true, including equal IDs.
 * Clearing the ID clears confirmation. No public-source inference is performed.
 *
 * @generated from message mono.datagateway.v1.UpdateOpportunityContextRequest
 */ export class UpdateOpportunityContextRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOpportunityContextRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOpportunityContextRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOpportunityContextRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOpportunityContextRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string actor_id = 3;
   */ _define_property(this, "actorId", ""), /**
   * @generated from field: mono.datagateway.v1.OpportunityOrganizationContext customer = 4;
   */ _define_property(this, "customer", void 0), /**
   * @generated from field: mono.datagateway.v1.OpportunityOrganizationContext contracting = 5;
   */ _define_property(this, "contracting", void 0), /**
   * @generated from field: bool confirm_customer = 6;
   */ _define_property(this, "confirmCustomer", false), /**
   * @generated from field: int32 expected_version = 7;
   */ _define_property(this, "expectedVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOpportunityContextRequest, "runtime", proto3);
_define_property(UpdateOpportunityContextRequest, "typeName", "mono.datagateway.v1.UpdateOpportunityContextRequest");
_define_property(UpdateOpportunityContextRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer",
            kind: "message",
            T: OpportunityOrganizationContext
        },
        {
            no: 5,
            name: "contracting",
            kind: "message",
            T: OpportunityOrganizationContext
        },
        {
            no: 6,
            name: "confirm_customer",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "expected_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateOpportunityContextResponse
 */ export class UpdateOpportunityContextResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOpportunityContextResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOpportunityContextResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOpportunityContextResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOpportunityContextResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityContext context = 1;
   */ _define_property(this, "context", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOpportunityContextResponse, "runtime", proto3);
_define_property(UpdateOpportunityContextResponse, "typeName", "mono.datagateway.v1.UpdateOpportunityContextResponse");
_define_property(UpdateOpportunityContextResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "context",
            kind: "message",
            T: OpportunityContext
        }
    ]));
/**
 * An append-only user assessment, always a candidate, never proof of absence.
 * Tracking Profile is morgans' TrackingProfile (NOT CaptureProfile). Its intent
 * snapshot is supplied by the trusted orchestrator after its authorized
 * TrackingProfile read; pangaea does not call morgans or authorize Profile access.
 *
 * @generated from message mono.datagateway.v1.OpportunityWhitespaceAssessment
 */ export class OpportunityWhitespaceAssessment extends Message {
    static fromBinary(bytes, options) {
        return new OpportunityWhitespaceAssessment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpportunityWhitespaceAssessment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpportunityWhitespaceAssessment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpportunityWhitespaceAssessment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string tracking_profile_id = 3;
   */ _define_property(this, "trackingProfileId", ""), /**
   * @generated from field: string profile_intent = 4;
   */ _define_property(this, "profileIntent", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: repeated string company_source_reference_ids = 6;
   */ _define_property(this, "companySourceReferenceIds", []), /**
   * @generated from field: repeated string market_source_reference_ids = 7;
   */ _define_property(this, "marketSourceReferenceIds", []), /**
   * @generated from field: repeated string coverage_ids = 8;
   */ _define_property(this, "coverageIds", []), /**
   * @generated from field: string coverage_state = 9;
   */ _define_property(this, "coverageState", ""), /**
   * @generated from field: string limitations = 10;
   */ _define_property(this, "limitations", ""), /**
   * undecided | matters | does_not_matter. Human decision, not evidence truth.
   *
   * @generated from field: string gap_decision = 11;
   */ _define_property(this, "gapDecision", ""), /**
   * @generated from field: string decision_reason = 12;
   */ _define_property(this, "decisionReason", ""), /**
   * @generated from field: string state = 13;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string explanation = 14;
   */ _define_property(this, "explanation", ""), /**
   * @generated from field: string assessed_by = 15;
   */ _define_property(this, "assessedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp assessed_at = 16;
   */ _define_property(this, "assessedAt", void 0), /**
   * Server-generated snapshot of selected source coverage, not company history.
   *
   * @generated from field: string coverage_summary = 17;
   */ _define_property(this, "coverageSummary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpportunityWhitespaceAssessment, "runtime", proto3);
_define_property(OpportunityWhitespaceAssessment, "typeName", "mono.datagateway.v1.OpportunityWhitespaceAssessment");
_define_property(OpportunityWhitespaceAssessment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tracking_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "profile_intent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "market_source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "coverage_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "coverage_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "gap_decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "decision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "assessed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "assessed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "coverage_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordOpportunityWhitespaceAssessmentRequest
 */ export class RecordOpportunityWhitespaceAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordOpportunityWhitespaceAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOpportunityWhitespaceAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOpportunityWhitespaceAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOpportunityWhitespaceAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string actor_id = 3;
   */ _define_property(this, "actorId", ""), /**
   * @generated from field: string tracking_profile_id = 4;
   */ _define_property(this, "trackingProfileId", ""), /**
   * @generated from field: string company_id = 5;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: repeated string company_source_reference_ids = 6;
   */ _define_property(this, "companySourceReferenceIds", []), /**
   * @generated from field: repeated string market_source_reference_ids = 7;
   */ _define_property(this, "marketSourceReferenceIds", []), /**
   * @generated from field: repeated string coverage_ids = 8;
   */ _define_property(this, "coverageIds", []), /**
   * @generated from field: string limitations = 9;
   */ _define_property(this, "limitations", ""), /**
   * @generated from field: string gap_decision = 10;
   */ _define_property(this, "gapDecision", ""), /**
   * @generated from field: string decision_reason = 11;
   */ _define_property(this, "decisionReason", ""), /**
   * Required, nonempty historical intent snapshot from morgans' TrackingProfile
   * (description and applicable filters). ONLY the trusted orchestrator may
   * supply this, after reading tracking_profile_id with the verified principal
   * and authorizing its access. Never forward a browser-supplied intent claim.
   * This internal gateway requires X-Admin-Secret plus the verified principal;
   * tenant_id/actor_id are optional assertions, never identity credentials.
   *
   * @generated from field: string validated_profile_intent = 12;
   */ _define_property(this, "validatedProfileIntent", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOpportunityWhitespaceAssessmentRequest, "runtime", proto3);
_define_property(RecordOpportunityWhitespaceAssessmentRequest, "typeName", "mono.datagateway.v1.RecordOpportunityWhitespaceAssessmentRequest");
_define_property(RecordOpportunityWhitespaceAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "tracking_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "company_source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "market_source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "coverage_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "limitations",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "gap_decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "decision_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "validated_profile_intent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordOpportunityWhitespaceAssessmentResponse
 */ export class RecordOpportunityWhitespaceAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordOpportunityWhitespaceAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordOpportunityWhitespaceAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordOpportunityWhitespaceAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordOpportunityWhitespaceAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityWhitespaceAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordOpportunityWhitespaceAssessmentResponse, "runtime", proto3);
_define_property(RecordOpportunityWhitespaceAssessmentResponse, "typeName", "mono.datagateway.v1.RecordOpportunityWhitespaceAssessmentResponse");
_define_property(RecordOpportunityWhitespaceAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: OpportunityWhitespaceAssessment
        }
    ]));
/**
 * Exact-ID read only. No unrestricted evidence/list projection. Caller must
 * reauthorize ALL saved inputs (Opportunity, Profile, company, source/coverage
 * IDs and associated source artifacts) before displaying any saved snapshot.
 * Tenant-scoped persistence checks here do not replace orchestrator authorization.
 *
 * @generated from message mono.datagateway.v1.GetOpportunityWhitespaceAssessmentRequest
 */ export class GetOpportunityWhitespaceAssessmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityWhitespaceAssessmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityWhitespaceAssessmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityWhitespaceAssessmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityWhitespaceAssessmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string assessment_id = 3;
   */ _define_property(this, "assessmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityWhitespaceAssessmentRequest, "runtime", proto3);
_define_property(GetOpportunityWhitespaceAssessmentRequest, "typeName", "mono.datagateway.v1.GetOpportunityWhitespaceAssessmentRequest");
_define_property(GetOpportunityWhitespaceAssessmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "assessment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOpportunityWhitespaceAssessmentResponse
 */ export class GetOpportunityWhitespaceAssessmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOpportunityWhitespaceAssessmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOpportunityWhitespaceAssessmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOpportunityWhitespaceAssessmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOpportunityWhitespaceAssessmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OpportunityWhitespaceAssessment assessment = 1;
   */ _define_property(this, "assessment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOpportunityWhitespaceAssessmentResponse, "runtime", proto3);
_define_property(GetOpportunityWhitespaceAssessmentResponse, "typeName", "mono.datagateway.v1.GetOpportunityWhitespaceAssessmentResponse");
_define_property(GetOpportunityWhitespaceAssessmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assessment",
            kind: "message",
            T: OpportunityWhitespaceAssessment
        }
    ]));
/**
 * SAD-1005: one pursuit as the Dashboard's pipeline counts it.
 *
 * @generated from message mono.datagateway.v1.PursuitPipelineRow
 */ export class PursuitPipelineRow extends Message {
    static fromBinary(bytes, options) {
        return new PursuitPipelineRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitPipelineRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitPipelineRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitPipelineRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * stage: shaping | qualifying | pursuing | no_bid | converted.
   *
   * @generated from field: string stage = 4;
   */ _define_property(this, "stage", ""), /**
   * value is capture_profiles.total_program_value as recorded (free text).
   *
   * @generated from field: string value = 5;
   */ _define_property(this, "value", ""), /**
   * on_team: the viewer is its capture manager or on its team.
   *
   * @generated from field: bool on_team = 6;
   */ _define_property(this, "onTeam", false), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * due_on are the days (YYYY-MM-DD, ascending) its pending go/no-go and
   * its open capture reviews are due.
   *
   * @generated from field: repeated string due_on = 8;
   */ _define_property(this, "dueOn", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitPipelineRow, "runtime", proto3);
_define_property(PursuitPipelineRow, "typeName", "mono.datagateway.v1.PursuitPipelineRow");
_define_property(PursuitPipelineRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "on_team",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPursuitPipelineRowsRequest
 */ export class ListPursuitPipelineRowsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitPipelineRowsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitPipelineRowsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitPipelineRowsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitPipelineRowsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * user_id is the viewer's platform user id (for on_team).
   *
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitPipelineRowsRequest, "runtime", proto3);
_define_property(ListPursuitPipelineRowsRequest, "typeName", "mono.datagateway.v1.ListPursuitPipelineRowsRequest");
_define_property(ListPursuitPipelineRowsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPursuitPipelineRowsResponse
 */ export class ListPursuitPipelineRowsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitPipelineRowsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitPipelineRowsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitPipelineRowsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitPipelineRowsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PursuitPipelineRow rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitPipelineRowsResponse, "runtime", proto3);
_define_property(ListPursuitPipelineRowsResponse, "typeName", "mono.datagateway.v1.ListPursuitPipelineRowsResponse");
_define_property(ListPursuitPipelineRowsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: PursuitPipelineRow,
            repeated: true
        }
    ]));
/**
 * Immutable history, independent of go/no-go and review records. Migrated rows
 * preserve exact legacy_stage; no_bid is an outcome, converted is never inferred closed.
 *
 * @generated from message mono.datagateway.v1.CaptureLifecycleEvent
 */ export class CaptureLifecycleEvent extends Message {
    static fromBinary(bytes, options) {
        return new CaptureLifecycleEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureLifecycleEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureLifecycleEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureLifecycleEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string request_id = 3;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: string action = 4;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string from_lifecycle = 5;
   */ _define_property(this, "fromLifecycle", ""), /**
   * @generated from field: string to_lifecycle = 6;
   */ _define_property(this, "toLifecycle", ""), /**
   * @generated from field: int64 revision = 7;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: string actor_user_id = 8;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp revisit_at = 10;
   */ _define_property(this, "revisitAt", void 0), /**
   * @generated from field: string outcome = 11;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: repeated string paused_task_ids = 12;
   */ _define_property(this, "pausedTaskIds", []), /**
   * @generated from field: optional string legacy_stage = 13;
   */ _define_property(this, "legacyStage", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CaptureLifecycleEvent, "runtime", proto3);
_define_property(CaptureLifecycleEvent, "typeName", "mono.datagateway.v1.CaptureLifecycleEvent");
_define_property(CaptureLifecycleEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "from_lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "to_lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "revisit_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "paused_task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 13,
            name: "legacy_stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ChangeCaptureLifecycleRequest
 */ export class ChangeCaptureLifecycleRequest extends Message {
    static fromBinary(bytes, options) {
        return new ChangeCaptureLifecycleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeCaptureLifecycleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeCaptureLifecycleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeCaptureLifecycleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", ""), /**
   * @generated from field: int64 expected_revision = 5;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * park|close|resume|record_outcome
   *
   * @generated from field: string action = 6;
   */ _define_property(this, "action", ""), /**
   * required for every action
   *
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", ""), /**
   * optional, park/close only
   *
   * @generated from field: google.protobuf.Timestamp revisit_at = 8;
   */ _define_property(this, "revisitAt", void 0), /**
   * optional on close; required for record_outcome
   *
   * @generated from field: string outcome = 9;
   */ _define_property(this, "outcome", ""), /**
   * optional, park/close only
   *
   * @generated from field: repeated string pause_task_ids = 10;
   */ _define_property(this, "pauseTaskIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChangeCaptureLifecycleRequest, "runtime", proto3);
_define_property(ChangeCaptureLifecycleRequest, "typeName", "mono.datagateway.v1.ChangeCaptureLifecycleRequest");
_define_property(ChangeCaptureLifecycleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "revisit_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "pause_task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ChangeCaptureLifecycleResponse
 */ export class ChangeCaptureLifecycleResponse extends Message {
    static fromBinary(bytes, options) {
        return new ChangeCaptureLifecycleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChangeCaptureLifecycleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChangeCaptureLifecycleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChangeCaptureLifecycleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CaptureProject capture_project = 1;
   */ _define_property(this, "captureProject", void 0), /**
   * @generated from field: mono.datagateway.v1.CaptureLifecycleEvent event = 2;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChangeCaptureLifecycleResponse, "runtime", proto3);
_define_property(ChangeCaptureLifecycleResponse, "typeName", "mono.datagateway.v1.ChangeCaptureLifecycleResponse");
_define_property(ChangeCaptureLifecycleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project",
            kind: "message",
            T: CaptureProject
        },
        {
            no: 2,
            name: "event",
            kind: "message",
            T: CaptureLifecycleEvent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureLifecycleEventsRequest
 */ export class ListCaptureLifecycleEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureLifecycleEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureLifecycleEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureLifecycleEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureLifecycleEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureLifecycleEventsRequest, "runtime", proto3);
_define_property(ListCaptureLifecycleEventsRequest, "typeName", "mono.datagateway.v1.ListCaptureLifecycleEventsRequest");
_define_property(ListCaptureLifecycleEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCaptureLifecycleEventsResponse
 */ export class ListCaptureLifecycleEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCaptureLifecycleEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCaptureLifecycleEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCaptureLifecycleEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCaptureLifecycleEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CaptureLifecycleEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCaptureLifecycleEventsResponse, "runtime", proto3);
_define_property(ListCaptureLifecycleEventsResponse, "typeName", "mono.datagateway.v1.ListCaptureLifecycleEventsResponse");
_define_property(ListCaptureLifecycleEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: CaptureLifecycleEvent,
            repeated: true
        }
    ]));
/**
 * Meeting context is independent of registry identity and grants no permission.
 *
 * @generated from message mono.datagateway.v1.TouchpointAttendeeContext
 */ export class TouchpointAttendeeContext extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointAttendeeContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointAttendeeContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointAttendeeContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointAttendeeContext, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attendee_id = 1;
   */ _define_property(this, "attendeeId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string organization = 3;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * customer|internal|partner, or unspecified
   *
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointAttendeeContext, "runtime", proto3);
_define_property(TouchpointAttendeeContext, "typeName", "mono.datagateway.v1.TouchpointAttendeeContext");
_define_property(TouchpointAttendeeContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attendee_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TouchpointParticipant
 */ export class TouchpointParticipant extends Message {
    static fromBinary(bytes, options) {
        return new TouchpointParticipant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TouchpointParticipant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TouchpointParticipant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TouchpointParticipant, a, b);
    }
    constructor(data){
        super(), /**
   * Stable client-minted UUID for adds; existing row ID for resolution.
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * Existing canonical Person only; empty leaves this attendee unresolved.
   *
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string attendee_name = 3;
   */ _define_property(this, "attendeeName", ""), /**
   * @generated from field: string organization = 4;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: string participant_role = 5;
   */ _define_property(this, "participantRole", ""), /**
   * @generated from field: string participation_kind = 6;
   */ _define_property(this, "participationKind", ""), /**
   * Read-only immutable contexts; combines originals on duplicate resolution.
   *
   * @generated from field: repeated mono.datagateway.v1.TouchpointAttendeeContext original_contexts = 7;
   */ _define_property(this, "originalContexts", []), /**
   * GRW-37 (D-SOR): the open REG-54 match candidate a typed attendee waits on.
   * A row has contact_id and no text, or a candidate
   * (chk_interaction_participants_link_only).
   *
   * @generated from field: string registry_candidate_id = 8;
   */ _define_property(this, "registryCandidateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TouchpointParticipant, "runtime", proto3);
_define_property(TouchpointParticipant, "typeName", "mono.datagateway.v1.TouchpointParticipant");
_define_property(TouchpointParticipant, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attendee_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "participant_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "participation_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "original_contexts",
            kind: "message",
            T: TouchpointAttendeeContext,
            repeated: true
        },
        {
            no: 8,
            name: "registry_candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * --- ResolvePursuitLink (GRW-37) ---
 * Binds a pursuit stakeholder or touchpoint attendee to a registry contact in
 * one transaction: sets contact_id, clears the typed text, keeps
 * registry_candidate_id as provenance. A stakeholder whose pursuit already has
 * a live stakeholder for that contact is folded into it (assessments move, the
 * unresolved row is soft-deleted); an attendee whose touchpoint already lists
 * that contact is folded into that row's original_contexts. When the touchpoint
 * carries an event (GRW-36) the contact is linked as ATTENDED.
 *
 * @generated from message mono.datagateway.v1.ResolvePursuitLinkRequest
 */ export class ResolvePursuitLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePursuitLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePursuitLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePursuitLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePursuitLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * the link must belong to this pursuit
   *
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * STAKEHOLDER | TOUCHPOINT_PARTICIPANT
   *
   * @generated from field: string link_kind = 3;
   */ _define_property(this, "linkKind", ""), /**
   * pursuit_stakeholders.id | customer_interaction_participants.id
   *
   * @generated from field: string link_id = 4;
   */ _define_property(this, "linkId", ""), /**
   * @generated from field: string contact_id = 5;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePursuitLinkRequest, "runtime", proto3);
_define_property(ResolvePursuitLinkRequest, "typeName", "mono.datagateway.v1.ResolvePursuitLinkRequest");
_define_property(ResolvePursuitLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "link_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolvePursuitLinkResponse
 */ export class ResolvePursuitLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolvePursuitLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvePursuitLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvePursuitLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvePursuitLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * the surviving contact written
   *
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: bool merged_into_existing_stakeholder = 2;
   */ _define_property(this, "mergedIntoExistingStakeholder", false), /**
   * the live stakeholder row after the fold (STAKEHOLDER)
   *
   * @generated from field: string stakeholder_id = 3;
   */ _define_property(this, "stakeholderId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvePursuitLinkResponse, "runtime", proto3);
_define_property(ResolvePursuitLinkResponse, "typeName", "mono.datagateway.v1.ResolvePursuitLinkResponse");
_define_property(ResolvePursuitLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "merged_into_existing_stakeholder",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "stakeholder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPursuitStakeholdersRequest
 */ export class ListPursuitStakeholdersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitStakeholdersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitStakeholdersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitStakeholdersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitStakeholdersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitStakeholdersRequest, "runtime", proto3);
_define_property(ListPursuitStakeholdersRequest, "typeName", "mono.datagateway.v1.ListPursuitStakeholdersRequest");
_define_property(ListPursuitStakeholdersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPursuitStakeholdersResponse
 */ export class ListPursuitStakeholdersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitStakeholdersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitStakeholdersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitStakeholdersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitStakeholdersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PursuitStakeholder stakeholders = 1;
   */ _define_property(this, "stakeholders", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitStakeholdersResponse, "runtime", proto3);
_define_property(ListPursuitStakeholdersResponse, "typeName", "mono.datagateway.v1.ListPursuitStakeholdersResponse");
_define_property(ListPursuitStakeholdersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "stakeholders",
            kind: "message",
            T: PursuitStakeholder,
            repeated: true
        }
    ]));
/**
 * Server-owned journal of standalone Pursuit role changes; independent of assessments.
 *
 * @generated from message mono.datagateway.v1.StakeholderRoleChange
 */ export class StakeholderRoleChange extends Message {
    static fromBinary(bytes, options) {
        return new StakeholderRoleChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StakeholderRoleChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StakeholderRoleChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StakeholderRoleChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string previous_role = 1;
   */ _define_property(this, "previousRole", ""), /**
   * @generated from field: string new_role = 2;
   */ _define_property(this, "newRole", ""), /**
   * @generated from field: google.protobuf.Timestamp changed_at = 3;
   */ _define_property(this, "changedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StakeholderRoleChange, "runtime", proto3);
_define_property(StakeholderRoleChange, "typeName", "mono.datagateway.v1.StakeholderRoleChange");
_define_property(StakeholderRoleChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "previous_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "new_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "changed_at",
            kind: "message",
            T: Timestamp
        }
    ]));
